export const en: Record<string, string> = {
  'Read-only view': 'Read-only view',
  'Viewing as client · read-only': 'Viewing as client · read-only',
  Exit: 'Exit',
  'Open menu': 'Open menu',
  'Client calendar opened in read-only preview': 'Client calendar opened in read-only preview',
  'AMY will prepare a different idea for this slot':
    'AMY will prepare a different idea for this slot',
  'Slot left intentionally empty': 'Slot left intentionally empty',
  'Comment saved': 'Comment saved',
  'Scheduled post stopped': 'Scheduled post stopped',
  'New winter menu idea': 'New winter menu idea',
  Agency: 'Agency',
  Platform: 'Platform',
  Workspace: 'Workspace',
  Search: 'Search',
  Notifications: 'Notifications',
  'You are all caught up': 'You are all caught up',
  'Signed in as Anna Nowak': 'Signed in as Anna Nowak',
  'Message sent to Hakusana': 'Message sent to Hakusana',
  Modules: 'Modules',
  'Social Media': 'Social Media',
  'Email marketing': 'Email marketing',
  Ads: 'Ads',
  Automations: 'Automations',
  'Coming soon — ask your agency': 'Coming soon — ask your agency',
  'Connected profiles': 'Connected profiles',
  'Facebook Page': 'Facebook Page',
  'Business account': 'Business account',
  'LinkedIn company page': 'LinkedIn company page',
  'Not connected': 'Not connected',
  'Invite to connect': 'Invite to connect',
  'Connect a profile': 'Connect a profile',
  'Manage connections': 'Manage connections',
  'Choose a channel to simulate connecting a profile.':
    'Choose a channel to simulate connecting a profile.',
  'LinkedIn company': 'LinkedIn company',
  'LinkedIn personal': 'LinkedIn personal',
  'Profile connected successfully': 'Profile connected successfully',
  'Invitation sent to Marek': 'Invitation sent to Marek',
  Planned: 'Planned',
  'AMY is working': 'AMY is working',
  'Needs your review': 'Needs your review',
  Approved: 'Approved',
  'Approved · Stopped': 'Approved · Stopped',
  Scheduled: 'Scheduled',
  Published: 'Published',
  'Published on 3 of 4': 'Published on 3 of 4',
  'Needs your input': 'Needs your input',
  'Intentionally empty': 'Intentionally empty',
  'Free slot': 'Free slot',
  Photo: 'Photo',
  Carousel: 'Carousel',
  Reel: 'Reel',
  Story: 'Story',
  PDF: 'PDF',
  Video: 'Video',
  Audio: 'Audio',
  'Finish setting up · {n} of 7 done': 'Finish setting up · {n} of 7 done',
  'Continue setup': 'Continue setup',
  'Awaiting approval from Anna Nowak': 'Awaiting approval from Anna Nowak',
  'A quick review keeps your calendar moving.': 'A quick review keeps your calendar moving.',
  'Previous week': 'Previous week',
  'Next week': 'Next week',
  '16 – 22 November 2026': '16 – 22 November 2026',
  'Week of 16 Nov': 'Week of 16 Nov',
  '{d} Nov': '{d} Nov',
  Mon: 'Mon',
  Tue: 'Tue',
  Wed: 'Wed',
  Thu: 'Thu',
  Fri: 'Fri',
  '{d} video': '{d} video',
  'Review posts': 'Review posts',
  '{i} of {n} · {posts} across {ch}': '{i} of {n} · {posts} across {ch}',
  '{day} November · {time} · Europe/Warsaw': '{day} November · {time} · Europe/Warsaw',
  'What changed': 'What changed',
  'Updated photo brightness and made the opening line warmer.':
    'Updated photo brightness and made the opening line warmer.',
  Before: 'Before',
  After: 'After',
  Caption: 'Caption',
  Comments: 'Comments',
  'All reviewed': 'All reviewed',
  'Nothing else needs your review right now.': 'Nothing else needs your review right now.',
  'Back to calendar': 'Back to calendar',
  'Reject idea': 'Reject idea',
  Comment: 'Comment',
  'Stop scheduled post': 'Stop scheduled post',
  'Only scheduled posts can be stopped': 'Only scheduled posts can be stopped',
  'This idea has been rejected. Would you like AMY to prepare a different idea for this slot?':
    'This idea has been rejected. Would you like AMY to prepare a different idea for this slot?',
  'Yes, create a new idea': 'Yes, create a new idea',
  'No, leave the slot empty': 'No, leave the slot empty',
  'Add a comment': 'Add a comment',
  'Write a note about this post': 'Write a note about this post',
  'Save comment': 'Save comment',
  Cancel: 'Cancel',
  'Request changes': 'Request changes',
  "Tell AMY what you'd like adjusted.": "Tell AMY what you'd like adjusted.",
  'Your feedback': 'Your feedback',
  'For example: brighten the photo and keep the caption as it is.':
    'For example: brighten the photo and keep the caption as it is.',
  'Apply to versions': 'Apply to versions',
  ' and ': ' and ',
  'Add material': 'Add material',
  'Send to AMY': 'Send to AMY',
  'Material picker opened': 'Material picker opened',
  Close: 'Close',
  General: 'General',
  'Winter menu campaign': 'Winter menu campaign',
  'Gingerbread latte': 'Gingerbread latte',
  'Your creative partner': 'Your creative partner',
  'AMY · {time}': 'AMY · {time}',
  'You · {time}': 'You · {time}',
  'You · just now': 'You · just now',
  'Good morning, Anna! I have two posts ready for review and a little idea for the winter menu. What would you like to work on?':
    'Good morning, Anna! I have two posts ready for review and a little idea for the winter menu. What would you like to work on?',
  'Review post': 'Review post',
  'Approve & schedule': 'Approve & schedule',
  More: 'More',
  'Post approved and scheduled': 'Post approved and scheduled',
  'AMY is working on {posts}… 60%': 'AMY is working on {posts}… 60%',
  'Ask AMY anything…': 'Ask AMY anything…',
  Send: 'Send',
  'Add attachment': 'Add attachment',
  'Close chat': 'Close chat',
  'Message sent to AMY': 'Message sent to AMY',
  'Choose a photo or document to attach': 'Choose a photo or document to attach',
  'Material bank': 'Material bank',
  'Your creative library for Brzoza Coffee': 'Your creative library for Brzoza Coffee',
  'Add photos, videos or audio': 'Add photos, videos or audio',
  'Choose files from your phone camera, library or computer':
    'Choose files from your phone camera, library or computer',
  'Connected folder · Last checked 5 min ago': 'Connected folder · Last checked 5 min ago',
  Connected: 'Connected',
  'Search materials': 'Search materials',
  'All files': 'All files',
  Photos: 'Photos',
  Videos: 'Videos',
  Uploaded: 'Uploaded',
  Drive: 'Drive',
  'Used in {x}': 'Used in {x}',
  'Winter counter': 'Winter counter',
  'Brzoza beans': 'Brzoza beans',
  'Weekend reel': 'Weekend reel',
  'Cafe at dusk': 'Cafe at dusk',
  'Latte art': 'Latte art',
  'Morning playlist': 'Morning playlist',
  'Upload queue': 'Upload queue',
  '100% · Processing preview': '100% · Processing preview',
  '42% · Keep this screen open': '42% · Keep this screen open',
  Paused: 'Paused',
  'Resume upload': 'Resume upload',
  'Pause upload': 'Pause upload',
  'Cancel upload': 'Cancel upload',
  'Preview processing cancelled': 'Preview processing cancelled',
  'Upload cancelled': 'Upload cancelled',
  'Missing material': 'Missing material',
  "Add clips for next week's Reels": "Add clips for next week's Reels",
  'Upload clips': 'Upload clips',
  'Use photos instead': 'Use photos instead',
  'Select video clips to upload': 'Select video clips to upload',
  'AMY will prepare a photo-based version': 'AMY will prepare a photo-based version',
  'Before uploading': 'Before uploading',
  'Video up to 10 GB · Image 200 MB · Audio 2 GB': 'Video up to 10 GB · Image 200 MB · Audio 2 GB',
  "Your photos and videos stay in your Google Drive. AMY only keeps copies of what's used in your posts.":
    "Your photos and videos stay in your Google Drive. AMY only keeps copies of what's used in your posts.",
  'Plan allowance': 'Plan allowance',
  'Your monthly publishing allowance. One post per channel per day.':
    'Your monthly publishing allowance. One post per channel per day.',
  '{x} this month': '{x} this month',
  'Tap to see usage details': 'Tap to see usage details',
  '{c}: {p} published · {r} reserved · {a} available':
    '{c}: {p} published · {r} reserved · {a} available',
  'AI usage': 'AI usage',
  'Billed by your AI provider': 'Billed by your AI provider',
  Estimate: 'Estimate',
  'Connected provider': 'Connected provider',
  'Estimated this month': 'Estimated this month',
  'Of estimated monthly usage': 'Of estimated monthly usage',
  'View usage details': 'View usage details',
  'AI usage details opened': 'AI usage details opened',
  Settings: 'Settings',
  'People, permissions and connected accounts.': 'People, permissions and connected accounts.',
  'People & permissions': 'People & permissions',
  'Invite contributor': 'Invite contributor',
  'Invite link copied for a new contributor': 'Invite link copied for a new contributor',
  Owner: 'Owner',
  Contributor: 'Contributor',
  'Can approve posts': 'Can approve posts',
  'Contributors can approve content for publishing.':
    'Contributors can approve content for publishing.',
  'Marek can approve content for publishing.': 'Marek can approve content for publishing.',
  'Can stop posts': 'Can stop posts',
  'Contributors can stop a scheduled post.': 'Contributors can stop a scheduled post.',
  'Marek can stop a scheduled post.': 'Marek can stop a scheduled post.',
  'Toggle post approvals': 'Toggle post approvals',
  'Toggle stopping posts': 'Toggle stopping posts',
  Connections: 'Connections',
  'Needs reconnecting': 'Needs reconnecting',
  'Invite Marek to connect': 'Invite Marek to connect',
  Manage: 'Manage',
  Reconnect: 'Reconnect',
  Invite: 'Invite',
  '{x}: connection action opened': '{x}: connection action opened',
  'Pause all publishing': 'Pause all publishing',
  'Stop all scheduled posts until you turn publishing back on.':
    'Stop all scheduled posts until you turn publishing back on.',
  'Publishing paused by Anna': 'Publishing paused by Anna',
  'The look, voice and feel AMY uses for Brzoza Coffee.':
    'The look, voice and feel AMY uses for Brzoza Coffee.',
  'Update brand style': 'Update brand style',
  'Brand style editor opened': 'Brand style editor opened',
  'Active style · v1': 'Active style · v1',
  Active: 'Active',
  'Warm, natural and quietly confident. A neighbourhood cafe with room to slow down.':
    'Warm, natural and quietly confident. A neighbourhood cafe with room to slow down.',
  Colours: 'Colours',
  Cream: 'Cream',
  Forest: 'Forest',
  Ink: 'Ink',
  Typography: 'Typography',
  'Approved sample posts': 'Approved sample posts',
  'Winter menu launch · Instagram': 'Winter menu launch · Instagram',
  'Our Warsaw morning · Facebook': 'Our Warsaw morning · Facebook',
  'Meet the roaster · LinkedIn': 'Meet the roaster · LinkedIn',
  'Approved by Anna · {n} Nov': 'Approved by Anna · {n} Nov',
  'Opened {x}': 'Opened {x}',
  'Version history': 'Version history',
  'v1 · Active': 'v1 · Active',
  'Published 3 November by Anna': 'Published 3 November by Anna',
  'v2 · Draft': 'v2 · Draft',
  'Updated 8 November': 'Updated 8 November',
  Preview: 'Preview',
  'Draft preview opened': 'Draft preview opened',
  "A simple view of what's working this month.": "A simple view of what's working this month.",
  'Export report': 'Export report',
  'Report export prepared': 'Report export prepared',
  'Reach this month · +18%': 'Reach this month · +18%',
  'Engagement · +0.8%': 'Engagement · +0.8%',
  'Posts published': 'Posts published',
  'Channel performance': 'Channel performance',
  '{x} reach': '{x} reach',
  'Ideas & campaigns': 'Ideas & campaigns',
  'Plan creative work together, one good idea at a time.':
    'Plan creative work together, one good idea at a time.',
  'New campaign': 'New campaign',
  'New campaign draft created': 'New campaign draft created',
  'Winter menu campaign ': 'Winter menu campaign ',
  'Slow mornings': 'Slow mornings',
  'Holiday opening hours': 'Holiday opening hours',
  '16–29 November': '16–29 November',
  'Always-on': 'Always-on',
  December: 'December',
  Draft: 'Draft',
  'Open campaign': 'Open campaign',
  '{x} opened': '{x} opened',
  'Finish setting up': 'Finish setting up',
  'A few quick steps to get Brzoza Coffee ready · {n} of 7 done':
    'A few quick steps to get Brzoza Coffee ready · {n} of 7 done',
  'Business details': 'Business details',
  'Brand & style': 'Brand & style',
  'Add your photos and videos': 'Add your photos and videos',
  'Connect AI': 'Connect AI',
  'Connect social accounts': 'Connect social accounts',
  'Approve sample posts': 'Approve sample posts',
  'Activate your plan': 'Activate your plan',
  '2–4 min': '2–4 min',
  '2–5 min each': '2–5 min each',
  '3–5 min': '3–5 min',
  '1 min': '1 min',
  Done: 'Done',
  'Saved for later · {time}': 'Saved for later · {time}',
  'Do this later': 'Do this later',
  Open: 'Open',
  Continue: 'Continue',
  '{x} marked complete': '{x} marked complete',
  '{x}: you can do this later': '{x}: you can do this later',
  'An API key lets AMY use your AI account. Your AI provider bills you separately.':
    'An API key lets AMY use your AI account. Your AI provider bills you separately.',
  'API key': 'API key',
  'Test connection': 'Test connection',
  'Ask someone to do this for me': 'Ask someone to do this for me',
  'Connection successful': 'Connection successful',
  'Finish this step': 'Finish this step',
  'Invite someone to connect AI': 'Invite someone to connect AI',
  Name: 'Name',
  Email: 'Email',
  'Send invitation': 'Send invitation',
  'Invitation sent to {name}': 'Invitation sent to {name}',
  calendar: 'Calendar',
  ideas: 'Ideas & campaigns',
  materials: 'Material bank',
  brand: 'Brand',
  reports: 'Reports',
  allowance: 'Plan allowance',
  settings: 'Settings',
  contact: 'Contact your agency',
  title: 'Your content calendar',
  subtitle: 'Winter menu · 16–29 November 2026',
  addIdea: 'Add an idea',
  review: '6 posts need your review',
  startReview: 'Start review',
  scheduled: 'Scheduled',
  published: 'Published',
  health: 'Publishing status',
  today: 'Today',
  month: 'Month',
  week: 'Week',
  list: 'List',
  previous: 'Previous',
  next: 'Next',
  owner: 'Client owner',
  contributor: 'Client contributor',
  agency: 'Agency staff',
  admin: 'Platform admin',
  chat: 'Chat with AMY',
  send: 'Send',
  placeholder: 'Ask AMY anything…',
  general: 'General',
  campaign: 'Winter menu',
  postThread: 'Gingerbread latte',
  reviewTitle: 'Review posts',
  approve: 'Approve & schedule',
  request: 'Request changes',
  more: 'More',
  close: 'Close',
  skip: 'Skip for now',
  approvedToast: 'Post approved and scheduled',
  changesToast: 'Your feedback was sent to AMY',
  ideaToast: 'Idea added to your calendar',
  upload: 'Add photos, videos or audio',
  all: 'All files',
  photos: 'Photos',
  videos: 'Videos',
  audio: 'Audio',
  search: 'Search',
  viewClient: 'View as client',
  prototype: 'Prototype: view as',
  mobile: 'Mobile preview',
  onboarding: 'Onboarding checklist',
  onePost: 'post',
  fewPosts: 'posts',
  manyPosts: 'posts',
  searchHint: 'Search workspace',
  agencyHome: 'Overview',
  platformHome: 'Platform home',
  roleOwner: 'Client owner',
  roleContributor: 'Client contributor',
  roleAgency: 'Agency staff',
  roleAdmin: 'Platform admin',
  'Posting times': 'Posting times',
  'Daily allowance': 'Daily allowance',
  reviewCount: '{n} {posts} {verb} your review',
  'reviewVerb.one': 'needs',
  'reviewVerb.other': 'need',
  'post.one': 'post',
  'post.other': 'posts',
  'postIn.one': 'post',
  'postIn.other': 'posts',
  'postWith.one': 'post',
  'postWith.other': 'posts',
  'channel.one': 'channel',
  'channel.other': 'channels',
  'channelIn.one': 'channel',
  'channelIn.other': 'channels',
  'idea.one': 'idea',
  'idea.other': 'ideas',
  'availability.one': 'available today',
  'availability.other': 'available today',
  'avail.one': 'post available',
  'avail.other': 'posts available',
  of: 'of',
  Language: 'Language',
  'Pause video': 'Pause video',
  'Play video': 'Play video',
  'Unmute video': 'Unmute video',
  'Mute video': 'Mute video',
  'Toggle captions': 'Toggle captions',
  'Choose version': 'Choose version',
  Back: 'Back',
  'Close menu': 'Close menu',
  Brand: 'Brand',
  Reports: 'Reports',
  CC: 'CC',
  'Week of {date}': 'Week of {date}',
  'Agency home': 'Agency home',
  'View as client': 'View as client',
  'Needs attention': 'Needs attention',
  Cause: 'Cause',
  'Affected items': 'Affected items',
  Age: 'Age',
  Action: 'Action',
  'Revision failed': 'Revision failed',
  'TikTok connection expired': 'TikTok connection expired',
  'Awaiting client review': 'Awaiting client review',
  'Waiting for client': 'Waiting for client',
  Retry: 'Retry',
  'Send reminder': 'Send reminder',
  'Open review': 'Open review',
  '{action}: started': '{action}: started',
  'Upcoming publications': 'Upcoming publications',
  'Today {time}': 'Today {time}',
  'Tomorrow {time}': 'Tomorrow {time}',
  Workspaces: 'Workspaces',
  Healthy: 'Healthy',
  '{n} for review': '{n} for review',
  'Open {name}': 'Open {name}',
  'item.one': 'item',
  'item.other': 'items',
  'Platform overview': 'Platform overview',
  'Platform settings and operational health.': 'Platform settings and operational health.',
  'Provider incident · TikTok media processing': 'Provider incident · TikTok media processing',
  'Some video revisions may take longer than usual.':
    'Some video revisions may take longer than usual.',
  'View details': 'View details',
  'Incident details opened': 'Incident details opened',
  Agencies: 'Agencies',
  agencyActive: 'Active',
  'workspace.one': 'workspace',
  'workspace.other': 'workspaces',
  'Social media': 'Social media',
  On: 'On',
  Configure: 'Configure',
  'Social media module settings opened': 'Social media module settings opened',
  'Coming soon': 'Coming soon',
  'Media operations': 'Media operations',
  'Max video length': 'Max video length',
  'Render-minutes alert': 'Render-minutes alert',
  '{value} per workspace': '{value} per workspace',
  Storage: 'Storage',
  'Originals deleted after processing': 'Originals deleted after processing',
  Copies: 'Copies',
  'Drive-linked or stored copies': 'Drive-linked or stored copies',
  'Edit limits': 'Edit limits',
  'Media operation settings opened': 'Media operation settings opened',
  'Support access log': 'Support access log',
  'Hakusana support viewed Brzoza Coffee': 'Hakusana support viewed Brzoza Coffee',
  '{name} approved access': '{name} approved access',
  'View access log': 'View access log',
  'Full support access log opened': 'Full support access log opened',
  'Daily slot settings': 'Daily slot settings',
  Channel: 'Channel',
  'Agency default': 'Agency default',
  'Workspace override': 'Workspace override',
  'Effective value': 'Effective value',
  Mode: 'Mode',
  Inherit: 'Inherit',
  Override: 'Override',
  '{n} per day': '{n} per day',
  '(Reel/Story)': '(Reel/Story)',
  '{channel}: {mode} selected': '{channel}: {mode} selected',
  'Changes apply to new bookings. Existing scheduled posts are kept.':
    'Changes apply to new bookings. Existing scheduled posts are kept.',
  Prototype: 'Prototype',
  'Prototype controls': 'Prototype controls',
  'Approve & schedule: {post}': 'Approve & schedule: {post}',
  Conversation: 'Conversation',
  '{name} · {n} new': '{name} · {n} new',
  'Reviewing: {post}': 'Reviewing: {post}',
  'Can you make a post about our new gingerbread latte for Monday morning?':
    'Can you make a post about our new gingerbread latte for Monday morning?',
  "Sure! I've drafted an Instagram Reel for Monday 16 November at 9:00. Want to review it now?":
    "Sure! I've drafted an Instagram Reel for Monday 16 November at 9:00. Want to review it now?",
  'Use the buttons under the post to approve or request changes. Ask AMY here if something is unclear.':
    'Use the buttons under the post to approve or request changes. Ask AMY here if something is unclear.',
  'Choose at least one version.': 'Choose at least one version.',
  'AMY will update the {v} versions: “{request}”': 'AMY will update the {v} versions: “{request}”',
  'Write what to change. AMY will update the {v} versions.':
    'Write what to change. AMY will update the {v} versions.',
  'TikTok needs reconnecting': 'TikTok needs reconnecting',
  'Anna Nowak can reconnect it in Settings': 'Anna Nowak can reconnect it in Settings',
  '3 of 4 channels working': '3 of 4 channels working',
  'Reconnect TikTok': 'Reconnect TikTok',
  Linked: 'Linked from Drive',
  'Used in posts': 'Used in posts',
  'Preparing media': 'Preparing media',
  'We keep an optimised copy for your posts. Keep your originals on your phone or drive.':
    'We keep an optimised copy for your posts. Keep your originals on your phone or drive.',
  'Which AI provider do you use?': 'Which AI provider do you use?',
  'Sign in to {provider}': 'Sign in to {provider}',
  'Use the account your business pays from. No account yet? You can create one on the same page.':
    'Use the account your business pays from. No account yet? You can create one on the same page.',
  'Open {provider}': 'Open {provider}',
  'Add a payment method': 'Add a payment method',
  '{provider} bills you directly for AI use. AMY never sees your card details.':
    '{provider} bills you directly for AI use. AMY never sees your card details.',
  'Open billing': 'Open billing',
  'Create a key named "AMY"': 'Create a key named "AMY"',
  'Choose "Create key", type AMY as the name, then copy the key. It is shown only once.':
    'Choose "Create key", type AMY as the name, then copy the key. It is shown only once.',
  'Paste it below and test': 'Paste it below and test',
  'AMY checks the key straight away and tells you if anything is missing.':
    'AMY checks the key straight away and tells you if anything is missing.',
  'What it costs': 'What it costs',
  'Example: about 30 posts a month usually costs a few euros of AI use. Prices checked {date}; your provider shows the exact amount.':
    'Example: about 30 posts a month usually costs a few euros of AI use. Prices checked {date}; your provider shows the exact amount.',
  'We will email them these steps and a secure link. You do not need to share your password.':
    'We will email them these steps and a secure link. You do not need to share your password.',
  'Ask Anna Nowak to change this, or suggest a change.':
    'Ask Anna Nowak to change this, or suggest a change.',
  'Tone of voice': 'Tone of voice',
  'Emoji, hashtags and calls to action': 'Emoji, hashtags and calls to action',
  'Words we use and avoid': 'Words we use and avoid',
  'Anything else AMY should know': 'Anything else AMY should know',
  '{hex} copied': '{hex} copied',
  'Brand update applied to future content and existing drafts':
    'Brand update applied to future content and existing drafts',
  'Brand update applied to future content': 'Brand update applied to future content',
  'Active · v1': 'Active · v1',
  'AMY uses this brand guide when creating and revising your content.':
    'AMY uses this brand guide when creating and revising your content.',
  'Suggestion sent to Anna Nowak': 'Suggestion sent to Anna Nowak',
  'Suggest a change': 'Suggest a change',
  'Preview draft v2': 'Preview draft v2',
  'Brand sections': 'Brand sections',
  'Brand basics': 'Brand basics',
  'Who you are and the facts AMY can rely on.': 'Who you are and the facts AMY can rely on.',
  'In one sentence': 'In one sentence',
  'A neighbourhood cafe in Warsaw that roasts its own beans.':
    'A neighbourhood cafe in Warsaw that roasts its own beans.',
  'Who we talk to': 'Who we talk to',
  'Locals, remote workers and weekend regulars, mostly 25–45.':
    'Locals, remote workers and weekend regulars, mostly 25–45.',
  'Key products': 'Key products',
  'Seasonal lattes, single-origin filter coffee, homemade cakes.':
    'Seasonal lattes, single-origin filter coffee, homemade cakes.',
  'Verified facts': 'Verified facts',
  'ul. Brzozowa 12, Warsaw · Beans roasted in Warsaw · Oat milk at no extra cost':
    'ul. Brzozowa 12, Warsaw · Beans roasted in Warsaw · Oat milk at no extra cost',
  'Opening hours and offers change often, so AMY reads them from Settings › Business details.':
    'Opening hours and offers change often, so AMY reads them from Settings › Business details.',
  'Visual style': 'Visual style',
  'Logos, colours, fonts and photo style.': 'Logos, colours, fonts and photo style.',
  'Brand assets': 'Brand assets',
  'Preview background': 'Preview background',
  'Choose brand files from your phone, computer or Drive':
    'Choose brand files from your phone, computer or Drive',
  'Add brand file': 'Add brand file',
  'Campaign photos and videos live in the Material bank.':
    'Campaign photos and videos live in the Material bank.',
  'Copy {hex}': 'Copy {hex}',
  'Readability checks': 'Readability checks',
  'Contrast between real text and background pairs. AA needs 4.5:1 for normal text and 3:1 for large text.':
    'Contrast between real text and background pairs. AA needs 4.5:1 for normal text and 3:1 for large text.',
  '{fg} on {bg}': '{fg} on {bg}',
  Fonts: 'Fonts',
  'Font not loaded, showing a fallback': 'Font not loaded, showing a fallback',
  'Winter menu': 'Winter menu',
  'Slow mornings, good coffee': 'Slow mornings, good coffee',
  'Our gingerbread latte is back, made with beans we roast ourselves in Warsaw. Come in and take the window seat.':
    'Our gingerbread latte is back, made with beans we roast ourselves in Warsaw. Come in and take the window seat.',
  'Photo style': 'Photo style',
  'Natural daylight, warm tones': 'Natural daylight, warm tones',
  'Real guests and staff, never stock photos': 'Real guests and staff, never stock photos',
  'Cups and cakes close up, wooden tables': 'Cups and cakes close up, wooden tables',
  'Logo use': 'Logo use',
  'Keep space around the logo the size of the leaf':
    'Keep space around the logo the size of the leaf',
  'Use the light logo on photos and dark colours': 'Use the light logo on photos and dark colours',
  'Never stretch, recolour or add effects': 'Never stretch, recolour or add effects',
  'How AMY writes': 'How AMY writes',
  'Choose how your posts should sound. AMY follows this for every caption.':
    'Choose how your posts should sound. AMY follows this for every caption.',
  'Choose one or more.': 'Choose one or more.',
  'Remove {word}': 'Remove {word}',
  'Add a word or phrase': 'Add a word or phrase',
  Add: 'Add',
  'Content languages': 'Content languages',
  'Polish · main language': 'Polish · main language',
  'Informal "Ty". Use Polish quotation marks „…”.':
    'Informal "Ty". Use Polish quotation marks „…”.',
  'English · for LinkedIn and tourists': 'English · for LinkedIn and tourists',
  'British spelling. Keep Polish place names.': 'British spelling. Keep Polish place names.',
  'Anything else AMY should know?': 'Anything else AMY should know?',
  'These notes guide writing only. They cannot change permissions, approvals or platform rules.':
    'These notes guide writing only. They cannot change permissions, approvals or platform rules.',
  '"Playful" and "Clear and professional" can pull in different directions. AMY will ask which one wins when they conflict.':
    '"Playful" and "Clear and professional" can pull in different directions. AMY will ask which one wins when they conflict.',
  'Examples & history': 'Examples & history',
  'What good looks like, and what to avoid.': 'What good looks like, and what to avoid.',
  'Good examples': 'Good examples',
  'Approved by Anna · {date}': 'Approved by Anna · {date}',
  Avoid: 'Avoid',
  'Change history': 'Change history',
  'Applied 3 November by Anna Nowak · First brand guide':
    'Applied 3 November by Anna Nowak · First brand guide',
  'Started 8 November by Marek (agency) · Added English notes':
    'Started 8 November by Marek (agency) · Added English notes',
  'Brand guide status': 'Brand guide status',
  'Active since {date}': 'Active since {date}',
  'Draft · changes: {n}': 'Draft · changes: {n}',
  'English language notes': 'English language notes',
  'Review and apply': 'Review and apply',
  'Anna Nowak applies brand updates.': 'Anna Nowak applies brand updates.',
  'The client owner applies brand updates. Your changes are saved as a draft.':
    'The client owner applies brand updates. Your changes are saved as a draft.',
  'Try this style': 'Try this style',
  'See how AMY would write a post with the draft settings.':
    'See how AMY would write a post with the draft settings.',
  'Write a sample post': 'Write a sample post',
  'Sample preview': 'Sample preview',
  'With your draft': 'With your draft',
  'With the active style': 'With the active style',
  'Apply brand updates': 'Apply brand updates',
  'v2 replaces v1 for new content.': 'v2 replaces v1 for new content.',
  'What changes': 'What changes',
  'Approved and scheduled posts keep the style they were approved with.':
    'Approved and scheduled posts keep the style they were approved with.',
  'Also update drafts that are not approved yet': 'Also update drafts that are not approved yet',
  'Main logo': 'Main logo',
  'For dark backgrounds': 'For dark backgrounds',
  Icon: 'Icon',
  Storefront: 'Storefront',
  'Profile pictures': 'Profile pictures',
  'PDF · 2 pages': 'PDF · 2 pages',
  'Use on light backgrounds': 'Use on light backgrounds',
  'Use on dark backgrounds': 'Use on dark backgrounds',
  Transparent: 'Transparent',
  Light: 'Light',
  Dark: 'Dark',
  Cinnamon: 'Cinnamon',
  'Birch bark': 'Birch bark',
  Primary: 'Primary',
  Background: 'Background',
  Text: 'Text',
  Accent: 'Accent',
  'Light accent': 'Light accent',
  'Captions and body text': 'Captions and body text',
  'Headlines on cream': 'Headlines on cream',
  'Text on green banners': 'Text on green banners',
  'Offer badges': 'Offer badges',
  'Small accent text': 'Small accent text',
  Headings: 'Headings',
  'Body text': 'Body text',
  Passes: 'Passes',
  'Large text only': 'Large text only',
  Fails: 'Fails',
  'Calm and warm': 'Calm and warm',
  'Friendly and relaxed': 'Friendly and relaxed',
  'Clear and professional': 'Clear and professional',
  Playful: 'Playful',
  'Slow mornings are better with a good cup. Come in, sit by the window.':
    'Slow mornings are better with a good cup. Come in, sit by the window.',
  'New on the menu: gingerbread latte. You know what to do ☕':
    'New on the menu: gingerbread latte. You know what to do ☕',
  'Our winter menu is available from 16 November, daily 8:00–19:00.':
    'Our winter menu is available from 16 November, daily 8:00–19:00.',
  'Warning: this gingerbread latte may cause spontaneous cosiness.':
    'Warning: this gingerbread latte may cause spontaneous cosiness.',
  Emoji: 'Emoji',
  Hashtags: 'Hashtags',
  'Call to action': 'Call to action',
  None: 'None',
  'A few (1–2)': 'A few (1–2)',
  Plenty: 'Plenty',
  'Our own (2)': 'Our own (2)',
  'Own and popular (3–5)': 'Own and popular (3–5)',
  'Gentle invitation': 'Gentle invitation',
  'Clear and direct': 'Clear and direct',
  'No call to action': 'No call to action',
  'Words we use': 'Words we use',
  'Words we avoid': 'Words we avoid',
  'Warm opening line, one clear invitation, two emoji.':
    'Warm opening line, one clear invitation, two emoji.',
  'Shows real people and the window seats.': 'Shows real people and the window seats.',
  'Professional, but still personal.': 'Professional, but still personal.',
  '"Best coffee in Warsaw!!!"': '"Best coffee in Warsaw!!!"',
  'Superlatives we cannot prove.': 'Superlatives we cannot prove.',
  'Stock photos of latte art': 'Stock photos of latte art',
  'Use our own photos instead.': 'Use our own photos instead.',
  'Rejected 6 Nov: "too formal" (Meet the roaster v1)':
    'Rejected 6 Nov: "too formal" (Meet the roaster v1)',
  'One-off feedback, not a rule.': 'One-off feedback, not a rule.',
  'Brand rule': 'Brand rule',
  'One-off': 'One-off',
  'Same as the active style. Change a setting to see the difference.':
    'Same as the active style. Change a setting to see the difference.',
  'Client view opened in read-only mode': 'Client view opened in read-only mode',
  'Demo data reset': 'Demo data reset',
  'Reset demo': 'Reset demo',
  'Viewing {ws} as the client · read-only': 'Viewing {ws} as the client · read-only',
  'Hakusana is working in {ws}. The client approves posts.':
    'Hakusana is working in {ws}. The client approves posts.',
  'Publishing is paused by {name}. Nothing is published until it is resumed.':
    'Publishing is paused by {name}. Nothing is published until it is resumed.',
  'Publishing resumed. Posts whose time passed during the pause will be offered new times.':
    'Publishing resumed. Posts whose time passed during the pause will be offered new times.',
  'Resume publishing': 'Resume publishing',
  '{network} connection expired': '{network} connection expired',
  'Reminder sent at {time}': 'Reminder sent at {time}',
  'Reminder sent to {name} (simulated)': 'Reminder sent to {name} (simulated)',
  'Open workspace': 'Open workspace',
  'Material missing': 'Material missing',
  'Open post': 'Open post',
  'Published on {ok} of {n}': 'Published on {ok} of {n}',
  'Nothing needs attention right now.': 'Nothing needs attention right now.',
  '{n} connection issue': '{n} connection issue',
  'View {name} as the client': 'View {name} as the client',
  'Your plan includes one post per channel per day. Unused days do not carry over.':
    'Your plan includes one post per channel per day. Unused days do not carry over.',
  'Choose a day': 'Choose a day',
  '1 of 1 slot available on this day': '1 of 1 slot available on this day',
  'This day has passed. Unused slots do not carry over.':
    'This day has passed. Unused slots do not carry over.',
  'The slot for this day is taken': 'The slot for this day is taken',
  'Next two weeks': 'Next two weeks',
  '{n} free days in the next two weeks': '{n} free days in the next two weeks',
  'Reconnect {network} to use these slots': 'Reconnect {network} to use these slots',
  'Billed by your AI provider, separately from your AMY plan':
    'Billed by your AI provider, separately from your AMY plan',
  'Estimated cost, 1–18 November': 'Estimated cost, 1–18 November',
  'AMY tasks this month (drafts and revisions)': 'AMY tasks this month (drafts and revisions)',
  Reserved: 'Reserved',
  Available: 'Available',
  'Not used': 'Not used',
  'Ask {name} to change this, or suggest a change.':
    'Ask {name} to change this, or suggest a change.',
  'No visible changes': 'No visible changes',
  'Brand guide v{v} is active. New content and unapproved drafts use it.':
    'Brand guide v{v} is active. New content and unapproved drafts use it.',
  'Brand guide v{v} is active for new content.': 'Brand guide v{v} is active for new content.',
  'Active · v{v}': 'Active · v{v}',
  'Draft v{v} · not used for new posts yet': 'Draft v{v} · not used for new posts yet',
  'Draft discarded. The active guide is unchanged.':
    'Draft discarded. The active guide is unchanged.',
  'Discard draft': 'Discard draft',
  'Add colour': 'Add colour',
  'Add font': 'Add font',
  'Approved by {name} · {date}': 'Approved by {name} · {date}',
  'v{v} · Draft': 'v{v} · Draft',
  'v{v} · Active': 'v{v} · Active',
  'v{v} · Replaced': 'v{v} · Replaced',
  'No changes yet': 'No changes yet',
  'Applied {date} by {name}': 'Applied {date} by {name}',
  '{name} applies brand updates.': '{name} applies brand updates.',
  'Change anything on this page to start a draft. AMY keeps using the active version until it is applied.':
    'Change anything on this page to start a draft. AMY keeps using the active version until it is applied.',
  'No draft in progress.': 'No draft in progress.',
  'Settings changed. Write a new sample to see the difference.':
    'Settings changed. Write a new sample to see the difference.',
  'v{next} replaces v{v} for new content.': 'v{next} replaces v{v} for new content.',
  'Write a new sample': 'Write a new sample',
  Secondary: 'Secondary',
  Custom: 'Custom',
  'Times in {tz}': 'Times in {tz}',
  'I have an idea for a post: ': 'I have an idea for a post: ',
  'Awaiting approval from {name}': 'Awaiting approval from {name}',
  'Nothing waiting for your review': 'Nothing waiting for your review',
  'AMY will let you know when new posts are ready.':
    'AMY will let you know when new posts are ready.',
  '{network} needs reconnecting': '{network} needs reconnecting',
  '{name} can reconnect it in Settings': '{name} can reconnect it in Settings',
  '{ok} of {n} channels working': '{ok} of {n} channels working',
  'Reconnect {network}': 'Reconnect {network}',
  'All channels connected': 'All channels connected',
  'Calendar view': 'Calendar view',
  'Previous month': 'Previous month',
  'Next month': 'Next month',
  'All channels are hidden. Choose at least one channel above.':
    'All channels are hidden. Choose at least one channel above.',
  'Nothing planned for this week yet': 'Nothing planned for this week yet',
  'AMY plans new weeks from your campaigns. You can also ask for something specific.':
    'AMY plans new weeks from your campaigns. You can also ask for something specific.',
  'Please plan posts for the week of {date}.': 'Please plan posts for the week of {date}.',
  'Ask AMY to plan this week': 'Ask AMY to plan this week',
  'Left empty on purpose': 'Left empty on purpose',
  'Open the week of {date}': 'Open the week of {date}',
  '+{n} more': '+{n} more',
  'Daily allowance today': 'Daily allowance today',
  'one post per channel per day': 'one post per channel per day',
  'reconnect first': 'reconnect first',
  'Nothing posted': 'Nothing posted',
  'Approved. “{title}” is scheduled.': 'Approved. “{title}” is scheduled.',
  'Task · {status}': 'Task · {status}',
  'demo, no real AI yet': 'demo, no real AI yet',
  Queued: 'Queued',
  Working: 'Working',
  Ready: 'Ready',
  Yesterday: 'Yesterday',
  'Good morning, Anna! Six posts are ready for your review, including the gingerbread latte for Thursday.':
    'Good morning, Anna! Six posts are ready for your review, including the gingerbread latte for Thursday.',
  'Done. The Instagram Reel is ready for Thursday 19 November at 9:00, with Facebook and TikTok versions.':
    'Done. The Instagram Reel is ready for Thursday 19 November at 9:00, with Facebook and TikTok versions.',
  'The winter menu plan runs from 16 to 29 November. Five posts are waiting for your review.':
    'The winter menu plan runs from 16 to 29 November. Five posts are waiting for your review.',
  'Yes. I will add it on Friday 27 November when I prepare the next batch.':
    'Yes. I will add it on Friday 27 November when I prepare the next batch.',
  'Add a cinnamon buns post to the winter menu': 'Add a cinnamon buns post to the winter menu',
  'I brightened the photo and made the opening line warmer, as you asked.':
    'I brightened the photo and made the opening line warmer, as you asked.',
  'Dzień dobry! Pierogi Thursday and the Friday jazz evening are ready for your review.':
    'Dzień dobry! Pierogi Thursday and the Friday jazz evening are ready for your review.',
  'Got it. I have added this as a task and will tell you here when a draft is ready for review.':
    'Got it. I have added this as a task and will tell you here when a draft is ready for review.',
  'The new version is ready. Have a look when you have a moment.':
    'The new version is ready. Have a look when you have a moment.',
  '{name} approved “{title}” ({channel}). It is scheduled.':
    '{name} approved “{title}” ({channel}). It is scheduled.',
  '{name} asked for changes to “{title}”: {text}': '{name} asked for changes to “{title}”: {text}',
  '{name} rejected “{title}”. AMY is preparing a different idea for the same slot.':
    '{name} rejected “{title}”. AMY is preparing a different idea for the same slot.',
  '{name} rejected “{title}”. The slot stays empty.':
    '{name} rejected “{title}”. The slot stays empty.',
  '{name} rejected “{title}”. The slot is on hold until someone decides.':
    '{name} rejected “{title}”. The slot is on hold until someone decides.',
  '{name} stopped “{title}” ({channel}). It stays on hold until someone resumes or reschedules it.':
    '{name} stopped “{title}” ({channel}). It stays on hold until someone resumes or reschedules it.',
  '{name} resumed “{title}”.': '{name} resumed “{title}”.',
  '{name} paused all publishing.': '{name} paused all publishing.',
  '{name} resumed publishing.': '{name} resumed publishing.',
  '{name} applied brand guide v{v}. AMY uses it for new content from now on.':
    '{name} applied brand guide v{v}. AMY uses it for new content from now on.',
  '{title}: new version ready for review': '{title}: new version ready for review',
  '{title} is ready for your review': '{title} is ready for your review',
  '{title}: published on {ok} of {n} accounts': '{title}: published on {ok} of {n} accounts',
  'Version {n} ready': 'Version {n} ready',
  'Draft created': 'Draft created',
  'Approved and scheduled': 'Approved and scheduled',
  'Asked for changes: {text}': 'Asked for changes: {text}',
  'Rejected · AMY prepares a different idea': 'Rejected · AMY prepares a different idea',
  'Rejected · slot left empty': 'Rejected · slot left empty',
  'Rejected · decide later': 'Rejected · decide later',
  'Replacement for “{title}”': 'Replacement for “{title}”',
  'Stopped before publishing': 'Stopped before publishing',
  'Resumed at the original time': 'Resumed at the original time',
  'A new idea for this slot.': 'A new idea for this slot.',
  'Retried after the earlier revision failed.': 'Retried after the earlier revision failed.',
  'Brightened the photo and made the opening line warmer.':
    'Brightened the photo and made the opening line warmer.',
  'Three short video clips (5–10 s) of latte art being poured.':
    'Three short video clips (5–10 s) of latte art being poured.',
  Rejected: 'Rejected',
  'Every day': 'Every day',
  'Autumn at Lipa': 'Autumn at Lipa',
  Events: 'Events',
  'Your creative library for {ws}': 'Your creative library for {ws}',
  'Nothing is missing right now.': 'Nothing is missing right now.',
  'For “{title}”, please use photos instead of video.':
    'For “{title}”, please use photos instead of video.',
  'Next prototype round': 'Next prototype round',
  'This view is planned but not built in the prototype yet. Nothing was changed or sent.':
    'This view is planned but not built in the prototype yet. Nothing was changed or sent.',
  OK: 'OK',
  'Invitation prepared for {name}. In this demo nothing is sent.':
    'Invitation prepared for {name}. In this demo nothing is sent.',
  'A few quick steps to get {ws} ready · {n} of 7 done':
    'A few quick steps to get {ws} ready · {n} of 7 done',
  'Demo: the key is checked only in this browser and never sent anywhere. Try a key containing "fail" or "billing" to see error states.':
    'Demo: the key is checked only in this browser and never sent anywhere. Try a key containing "fail" or "billing" to see error states.',
  'Paste your API key first.': 'Paste your API key first.',
  'This key looks too short. Copy the whole key from {provider}.':
    'This key looks too short. Copy the whole key from {provider}.',
  '{provider} did not accept this key. Create a new key and try again.':
    '{provider} did not accept this key. Create a new key and try again.',
  'The key works, but {provider} needs a payment method first. Open billing, add a card, then test again.':
    'The key works, but {provider} needs a payment method first. Open billing, add a card, then test again.',
  'Approved. “{title}” is scheduled for {when} at {time}.':
    'Approved. “{title}” is scheduled for {when} at {time}.',
  'Sent to AMY. The new version will appear here when it is ready.':
    'Sent to AMY. The new version will appear here when it is ready.',
  'Rejected. AMY is preparing a different idea for this slot.':
    'Rejected. AMY is preparing a different idea for this slot.',
  'Rejected. The slot stays empty.': 'Rejected. The slot stays empty.',
  'Rejected. The slot waits for your decision.': 'Rejected. The slot waits for your decision.',
  'Stopped. It will not be published until someone resumes it.':
    'Stopped. It will not be published until someone resumes it.',
  '{name} approves posts for {ws}': '{name} approves posts for {ws}',
  'Post details': 'Post details',
  '{i} of {n} · {posts} waiting for review': '{i} of {n} · {posts} waiting for review',
  'Document · {n} pages': 'Document · {n} pages',
  'Page {i} of {n}': 'Page {i} of {n}',
  'Previous page': 'Previous page',
  'Next page': 'Next page',
  'Previous slide': 'Previous slide',
  'Next slide': 'Next slide',
  'Read the caption': 'Read the caption',
  'Versions of this post': 'Versions of this post',
  'Content language: {lang}': 'Content language: {lang}',
  'Version {n}': 'Version {n}',
  'What changed in version {n}': 'What changed in version {n}',
  Activity: 'Activity',
  'Stop this post': 'Stop this post',
  'Only {name} can stop scheduled posts': 'Only {name} can stop scheduled posts',
  'Request a revision': 'Request a revision',
  'Resumed. It is scheduled again for {when} at {time}.':
    'Resumed. It is scheduled again for {when} at {time}.',
  'Resume at the original time': 'Resume at the original time',
  'Please find a new time for “{title}” ({channel}).':
    'Please find a new time for “{title}” ({channel}).',
  'Ask AMY for a new time': 'Ask AMY for a new time',
  'About “{title}” on {when}: ': 'About “{title}” on {when}: ',
  'Tell AMY something about this post': 'Tell AMY something about this post',
  'Please move “{title}” to another time.': 'Please move “{title}” to another time.',
  'Suggest a different time': 'Suggest a different time',
  'Add the material': 'Add the material',
  'Please suggest a new idea for {channel} on {when}.':
    'Please suggest a new idea for {channel} on {when}.',
  'Ask AMY for an idea': 'Ask AMY for an idea',
  'Decide later': 'Decide later',
  'Stop this post?': 'Stop this post?',
  '“{title}” will not be published on {when} at {time}. It stays on hold until someone resumes it or asks for a new time.':
    '“{title}” will not be published on {when} at {time}. It stays on hold until someone resumes it or asks for a new time.',
  'Only the {channel} version stops. The other versions stay scheduled.':
    'Only the {channel} version stops. The other versions stay scheduled.',
  'Stop post': 'Stop post',
  'Keep it scheduled': 'Keep it scheduled',
  'Published at {time} · demo result, no real post':
    'Published at {time} · demo result, no real post',
  'Reach after 24 hours (simulated): {n}': 'Reach after 24 hours (simulated): {n}',
  'Publishing is paused. This post waits until publishing is resumed.':
    'Publishing is paused. This post waits until publishing is resumed.',
  'Scheduled. You can still stop it or ask for a revision before it goes out.':
    'Scheduled. You can still stop it or ask for a revision before it goes out.',
  'Stopped. Its time has passed, so ask AMY for a new time if you still want it.':
    'Stopped. Its time has passed, so ask AMY for a new time if you still want it.',
  'Stopped and on hold. It will not be published until someone resumes it.':
    'Stopped and on hold. It will not be published until someone resumes it.',
  'AMY is preparing version {n}…': 'AMY is preparing version {n}…',
  'You will get a notification when it is ready to review.':
    'You will get a notification when it is ready to review.',
  'Planned. AMY writes the first draft about three days before it is due.':
    'Planned. AMY writes the first draft about three days before it is due.',
  'AMY needs material for this post': 'AMY needs material for this post',
  'This slot was left empty on purpose. Nothing will be published.':
    'This slot was left empty on purpose. Nothing will be published.',
  'This idea was rejected and will not be published.':
    'This idea was rejected and will not be published.',
  'Post not found': 'Post not found',
  'This post is no longer available': 'This post is no longer available',
  'Nothing else needs your review right now. Approved posts are on the calendar.':
    'Nothing else needs your review right now. Approved posts are on the calendar.',
  'It may have been removed or replaced.': 'It may have been removed or replaced.',
  'Not published': 'Not published',
  'Marek has not connected his LinkedIn account yet.':
    'Marek has not connected his LinkedIn account yet.',
  'Sample figures': 'Sample figures',
  'Other versions keep their approval and schedule.':
    'Other versions keep their approval and schedule.',
  'Only {name} can change this': 'Only {name} can change this',
  '{name} can approve content for publishing.': '{name} can approve content for publishing.',
  '{name} can review and comment, but cannot approve.':
    '{name} can review and comment, but cannot approve.',
  '{name} can stop a scheduled post.': '{name} can stop a scheduled post.',
  '{name} cannot stop scheduled posts.': '{name} cannot stop scheduled posts.',
  'Connected by {name}': 'Connected by {name}',
  'Profile reconnected (simulated)': 'Profile reconnected (simulated)',
  'Nothing is published while paused. {n} scheduled posts would wait.':
    'Nothing is published while paused. {n} scheduled posts would wait.',
  'Publishing paused for {ws}.': 'Publishing paused for {ws}.',
  'Publishing paused by {name}': 'Publishing paused by {name}',
  'Profile connected (simulated)': 'Profile connected (simulated)',
  'Message sent to Hakusana. They usually reply within one working day.':
    'Message sent to Hakusana. They usually reply within one working day.',
  'You are all caught up.': 'You are all caught up.',
  'Message Hakusana': 'Message Hakusana',
  'Your agency team sees this together with {ws}.':
    'Your agency team sees this together with {ws}.',
  'Your message': 'Your message',
  'For example: can we plan posts for our Christmas opening hours?':
    'For example: can we plan posts for our Christmas opening hours?',
  'Send message': 'Send message',
  'Search {ws}': 'Search {ws}',
  'Nothing matches “{q}” in {ws}.': 'Nothing matches “{q}” in {ws}.',
  Posts: 'Posts',
  Materials: 'Materials',
  Conversations: 'Conversations',
  Pages: 'Pages',
  'Open it from the AMY chat': 'Open it from the AMY chat',
  'Mark all as read': 'Mark all as read',
  'Reset demo data': 'Reset demo data',
  'Sign out is not part of this demo': 'Sign out is not part of this demo',
  'Client owner': 'Client owner',
  'Client contributor': 'Client contributor',
  'Agency staff': 'Agency staff',
  'Platform admin': 'Platform admin',
  'AI usage details': 'AI usage details',
  'Add or replace a brand file': 'Add or replace a brand file',
  'Add, edit or remove a colour': 'Add, edit or remove a colour',
  'Attach photos, videos or documents': 'Attach photos, videos or documents',
  'Campaign details': 'Campaign details',
  'Cancel an upload': 'Cancel an upload',
  'Choose a font from Google Fonts': 'Choose a font from Google Fonts',
  'Choose material for this change': 'Choose material for this change',
  'Configure the Social Media module': 'Configure the Social Media module',
  'Create a campaign': 'Create a campaign',
  'Edit media limits': 'Edit media limits',
  'Export a report': 'Export a report',
  'Incident details': 'Incident details',
  'Invite a contributor': 'Invite a contributor',
  'Invite someone to connect their personal LinkedIn':
    'Invite someone to connect their personal LinkedIn',
  'Manage a connected account': 'Manage a connected account',
  'Manage an agency': 'Manage an agency',
  'Suggest a brand change': 'Suggest a brand change',
  'Upload clips for this post': 'Upload clips for this post',
  'Upload photos, videos or audio': 'Upload photos, videos or audio',
  TikTok: 'TikTok',
  '{status} · reconnect {network}': '{status} · reconnect {network}',
  '{network} needs reconnecting before this can be published':
    '{network} needs reconnecting before this can be published',
  'The approval is kept. Reconnect {account} and the post goes out as planned; if the time passes first, AMY asks for a new time.':
    'The approval is kept. Reconnect {account} and the post goes out as planned; if the time passes first, AMY asks for a new time.',
  'You can still approve it. It will only be published once {account} is reconnected.':
    'You can still approve it. It will only be published once {account} is reconnected.',
  'The {channel} slot on {when} is now taken by another post. Ask AMY for a new time instead.':
    'The {channel} slot on {when} is now taken by another post. Ask AMY for a new time instead.',
  'Only the {channel} version stops. Other versions keep their current status.':
    'Only the {channel} version stops. Other versions keep their current status.',
  Build: 'Build',
  'Build being tested': 'Build being tested',
  'Colour added: {name}': 'Colour added: {name}',
  'Colour changed: {name}': 'Colour changed: {name}',
  'Colour removed: {name}': 'Colour removed: {name}',
  '{family} set for {role} in the draft': '{family} set for {role} in the draft',
  '{role} need a font. Choose a replacement for {family}.':
    '{role} need a font. Choose a replacement for {family}.',
  '{family} removed from the draft': '{family} removed from the draft',
  '{name} removed from the draft': '{name} removed from the draft',
  'Replaced in the draft. Approved posts keep the previous file.':
    'Replaced in the draft. Approved posts keep the previous file.',
  'Removed from the brand draft. The file stays in its original place.':
    'Removed from the brand draft. The file stays in its original place.',
  'You are editing a draft{by}. Changes save automatically; AMY keeps using v{v} until the draft is applied.':
    'You are editing a draft{by}. Changes save automatically; AMY keeps using v{v} until the draft is applied.',
  Edit: 'Edit',
  'Saved to the brand draft': 'Saved to the brand draft',
  'Save to draft': 'Save to draft',
  Replace: 'Replace',
  'Edit {name}': 'Edit {name}',
  Change: 'Change',
  Remove: 'Remove',
  'Add a photo guideline': 'Add a photo guideline',
  'Add a logo rule': 'Add a logo rule',
  'Rules for each language AMY writes in. The app language does not change your content.':
    'Rules for each language AMY writes in. The app language does not change your content.',
  'Notes for {lang}': 'Notes for {lang}',
  'Add example': 'Add example',
  'Saved as a proposed brand rule in the draft': 'Saved as a proposed brand rule in the draft',
  'Make this a brand rule': 'Make this a brand rule',
  'v{v} copied into a new draft. Review and apply it to use it again.':
    'v{v} copied into a new draft. Review and apply it to use it again.',
  'Restore as draft': 'Restore as draft',
  'What should the post be about? (optional)': 'What should the post be about? (optional)',
  'For example: Saturday coffee tasting': 'For example: Saturday coffee tasting',
  'Sample preview · not a scheduled post': 'Sample preview · not a scheduled post',
  'Draft v{v} · changes: {n}': 'Draft v{v} · changes: {n}',
  'Review changes': 'Review changes',
  'Saved automatically': 'Saved automatically',
  'Why it is a good example': 'Why it is a good example',
  'Example removed from the draft': 'Example removed from the draft',
  'Remove example': 'Remove example',
  'Add a good example': 'Add a good example',
  'Published post': 'Published post',
  'Why is it a good example?': 'Why is it a good example?',
  'For example: short, warm and shows real guests':
    'For example: short, warm and shows real guests',
  'Example added to the draft': 'Example added to the draft',
  'Add to draft': 'Add to draft',
  'Draft by {name}': 'Draft by {name}',
  'What is it for?': 'What is it for?',
  'Any background': 'Any background',
  'Usage note (optional)': 'Usage note (optional)',
  'For example: profile pictures': 'For example: profile pictures',
  Source: 'Source',
  'Remove from brand': 'Remove from brand',
  'AMY stops using this file for new posts. The file itself is not deleted.':
    'AMY stops using this file for new posts. The file itself is not deleted.',
  'Saved to the brand draft. Approved posts keep their colours.':
    'Saved to the brand draft. Approved posts keep their colours.',
  'Enter a HEX code to preview': 'Enter a HEX code to preview',
  'Pick a colour': 'Pick a colour',
  'Use six characters after #, for example #365A48.':
    'Use six characters after #, for example #365A48.',
  '{name} already uses this colour. You can still save it with another role.':
    '{name} already uses this colour. You can still save it with another role.',
  'For example: Forest green': 'For example: Forest green',
  'Another colour already has this name.': 'Another colour already has this name.',
  Role: 'Role',
  'When to use it (optional)': 'When to use it (optional)',
  'For example: offer badges only': 'For example: offer badges only',
  'Remove {name} from the brand draft? Readability checks that use it are removed too.':
    'Remove {name} from the brand draft? Readability checks that use it are removed too.',
  'Remove colour': 'Remove colour',
  'From the Google Fonts library': 'From the Google Fonts library',
  'Search font families': 'Search font families',
  Show: 'Show',
  'Supports Polish letters': 'Supports Polish letters',
  'Preview text': 'Preview text',
  'Demo catalogue: {n} of {total}+ Google Fonts families. The live app searches the full library.':
    'Demo catalogue: {n} of {total}+ Google Fonts families. The live app searches the full library.',
  'No fonts match. Try another name or category.': 'No fonts match. Try another name or category.',
  'No Polish letters': 'No Polish letters',
  'Use this font for': 'Use this font for',
  '{file} is not a supported type here.': '{file} is not a supported type here.',
  'Choose from your phone or computer': 'Choose from your phone or computer',
  'Photos, videos, audio and documents. No small size limits: AMY keeps an optimised copy for your posts.':
    'Photos, videos, audio and documents. No small size limits: AMY keeps an optimised copy for your posts.',
  'Demo: only small photos are previewed in this browser; nothing is uploaded to a server.':
    'Demo: only small photos are previewed in this browser; nothing is uploaded to a server.',
  'The Material bank is empty.': 'The Material bank is empty.',
  'Linked folder': 'Linked folder',
  '{n} files': '{n} files',
  'This folder is empty.': 'This folder is empty.',
  'Files stay in your Drive. AMY only prepares a copy of the files you use.':
    'Files stay in your Drive. AMY only prepares a copy of the files you use.',
  'Selected: {n}': 'Selected: {n}',
  'Nothing selected yet': 'Nothing selected yet',
  'Use selected': 'Use selected',
  'Change font': 'Change font',
  'Add a font': 'Add a font',
  Recommended: 'Recommended',
  'All fonts': 'All fonts',
  All: 'All',
  'Sans serif': 'Sans serif',
  Serif: 'Serif',
  Display: 'Display',
  Handwriting: 'Handwriting',
  Monospace: 'Monospace',
  Loaded: 'Loaded',
  'Loading…': 'Loading…',
  'Could not load, showing a fallback': 'Could not load, showing a fallback',
  'Replace in draft': 'Replace in draft',
  'Add to brand draft': 'Add to brand draft',
  'Edit colour': 'Edit colour',
  'Add a colour': 'Add a colour',
  '{name} updated in the draft': '{name} updated in the draft',
  '{name} added to the draft': '{name} added to the draft',
  'Add a brand file': 'Add a brand file',
  'Replace a brand file': 'Replace a brand file',
  'Edit brand file': 'Edit brand file',
  'Brand reference': 'Brand reference',
  Upload: 'Upload',
  'Google Drive': 'Google Drive',
  'Choose one or more files': 'Choose one or more files',
  'Choose one file': 'Choose one file',
  Document: 'Document',
  'Linked from Drive': 'Linked from Drive',
  Menu: 'Menu',
  'Shared folder': 'Shared folder',
  'Step {n} of 2': 'Step {n} of 2',
  'AMY asks for read-only access to one folder. It cannot change or delete anything in your Drive.':
    'AMY asks for read-only access to one folder. It cannot change or delete anything in your Drive.',
  'What should AMY use?': 'What should AMY use?',
  'A folder in my Drive': 'A folder in my Drive',
  'Signed in as {account}': 'Signed in as {account}',
  'Folder name': 'Folder name',
  'A shared folder link': 'A shared folder link',
  'For a folder someone else owns, like your photographer.':
    'For a folder someone else owns, like your photographer.',
  'Folder link': 'Folder link',
  'This does not look like a Google Drive folder link.':
    'This does not look like a Google Drive folder link.',
  'Check access': 'Check access',
  'Disconnect Drive': 'Disconnect Drive',
  'AMY stops listing Drive files. Photos already used in posts stay in those posts.':
    'AMY stops listing Drive files. Photos already used in posts stay in those posts.',
  'Google Drive disconnected': 'Google Drive disconnected',
  Disconnect: 'Disconnect',
  'AMY can open “{folder}”: {n} files in {f} folders.':
    'AMY can open “{folder}”: {n} files in {f} folders.',
  'What AMY will see': 'What AMY will see',
  'Only this folder and the folders inside it.': 'Only this folder and the folders inside it.',
  'Files are listed, not copied. AMY prepares a copy only when a file is used in a post.':
    'Files are listed, not copied. AMY prepares a copy only when a file is used in a post.',
  'New files show up when the folder is checked, at least once a day.':
    'New files show up when the folder is checked, at least once a day.',
  'Google Drive connected: {folder}': 'Google Drive connected: {folder}',
  'Connect this folder': 'Connect this folder',
  'Folder path': 'Folder path',
  '{n} files in this folder': '{n} files in this folder',
  'Show more ({n} left)': 'Show more ({n} left)',
  'Choose files to add to the Material bank': 'Choose files to add to the Material bank',
  '{n} already in the library': '{n} already in the library',
  '{n} files linked. AMY is preparing them for posts.':
    '{n} files linked. AMY is preparing them for posts.',
  'These files are already in the library.': 'These files are already in the library.',
  'Add to Material bank': 'Add to Material bank',
  '{n} files added to the upload queue': '{n} files added to the upload queue',
  'AMY can no longer open this folder. Ask the folder owner to share it again, or choose another folder.':
    'AMY can no longer open this folder. Ask the folder owner to share it again, or choose another folder.',
  'Linked folder · {n} files · checked at {time}': 'Linked folder · {n} files · checked at {time}',
  Browse: 'Browse',
  'Folder checked. {n} files, nothing new.': 'Folder checked. {n} files, nothing new.',
  Refresh: 'Refresh',
  'Access restored (simulated)': 'Access restored (simulated)',
  'Fix access': 'Fix access',
  'Demo only': 'Demo only',
  'Simulate lost access': 'Simulate lost access',
  'Change folder': 'Change folder',
  'Use your Google Drive as a library': 'Use your Google Drive as a library',
  'Link one folder. AMY lists the files and only copies the ones you use in posts. Nothing is imported in bulk.':
    'Link one folder. AMY lists the files and only copies the ones you use in posts. Nothing is imported in bulk.',
  'Connect a folder': 'Connect a folder',
  'AMY needs material': 'AMY needs material',
  'Add clips': 'Add clips',
  'Search names and tags': 'Search names and tags',
  'Show archived': 'Show archived',
  Tags: 'Tags',
  Favourite: 'Favourite',
  'Uploading and preparing are separate steps. You can close the app while files prepare.':
    'Uploading and preparing are separate steps. You can close the app while files prepare.',
  'Nothing uploading right now.': 'Nothing uploading right now.',
  'Finished ({n})': 'Finished ({n})',
  'You can keep using the app.': 'You can keep using the app.',
  'Simulate drop': 'Simulate drop',
  'Keep both': 'Keep both',
  Dismiss: 'Dismiss',
  Renamed: 'Renamed',
  Rename: 'Rename',
  'Add a tag': 'Add a tag',
  Status: 'Status',
  'Ready for posts': 'Ready for posts',
  'Good for': 'Good for',
  'Not used in any post yet.': 'Not used in any post yet.',
  'Restored to the library': 'Restored to the library',
  Restore: 'Restore',
  Archive: 'Archive',
  'It is used in {n} posts. Those posts keep their copy; AMY just stops suggesting it.':
    'It is used in {n} posts. Those posts keep their copy; AMY just stops suggesting it.',
  'AMY stops suggesting it. You can restore it from “Show archived”.':
    'AMY stops suggesting it. You can restore it from “Show archived”.',
  Archived: 'Archived',
  'with files: {names}': 'with files: {names}',
  'AMY uses these files for the new version.': 'AMY uses these files for the new version.',
  Uploading: 'Uploading',
  'Preparing for posts': 'Preparing for posts',
  'Upload stopped': 'Upload stopped',
  'Cannot be used': 'Cannot be used',
  'Already in the Material bank': 'Already in the Material bank',
  Cancelled: 'Cancelled',
  'No access': 'No access',
  'Paused. Resume any time; it continues where it stopped.':
    'Paused. Resume any time; it continues where it stopped.',
  'Cancelled. Nothing was added.': 'Cancelled. Nothing was added.',
  'This file type cannot be used in posts. Export a JPG, PNG, MP4 or PDF instead.':
    'This file type cannot be used in posts. Export a JPG, PNG, MP4 or PDF instead.',
  'Already in the Material bank as “{name}”.': 'Already in the Material bank as “{name}”.',
  'The connection dropped at {p}%. Retry continues from where it stopped.':
    'The connection dropped at {p}%. Retry continues from where it stopped.',
  'Paused when the phone went to sleep. Resume when you are on Wi-Fi.':
    'Paused when the phone went to sleep. Resume when you are on Wi-Fi.',
  'Photoshop files cannot be used in posts. Export a JPG or PNG instead.':
    'Photoshop files cannot be used in posts. Export a JPG or PNG instead.',
  Reels: 'Reels',
  Stories: 'Stories',
  'Feed posts': 'Feed posts',
  Carousels: 'Carousels',
  'LinkedIn documents': 'LinkedIn documents',
  'Reels background': 'Reels background',
  'Add more material': 'Add more material',
  'Add clips for this post': 'Add clips for this post',
  'Choose photos for this post': 'Choose photos for this post',
  'Clips added. AMY is preparing the post and will ask you to review it.':
    'Clips added. AMY is preparing the post and will ask you to review it.',
  'Photos chosen. AMY is preparing a carousel and will ask you to review it.':
    'Photos chosen. AMY is preparing a carousel and will ask you to review it.',
  'Zoom in': 'Zoom in',
  'Zoom out': 'Zoom out',
  'Add to favourites': 'Add to favourites',
  Documents: 'Documents',
  'AMY can no longer open the linked Drive folder. Fix access in the Material bank.':
    'AMY can no longer open the linked Drive folder. Fix access in the Material bank.',
  'Google Drive is not connected for this workspace. Connect a folder in the Material bank.':
    'Google Drive is not connected for this workspace. Connect a folder in the Material bank.',
  'Added clips: {names}': 'Added clips: {names}',
  'Chose photos instead: {names}': 'Chose photos instead: {names}',
  '{name} added clips for “{title}”. AMY is preparing it.':
    '{name} added clips for “{title}”. AMY is preparing it.',
  '{name} chose photos instead of video for “{title}”. AMY is preparing a carousel.':
    '{name} chose photos instead of video for “{title}”. AMY is preparing a carousel.',
  'Made with the clips you added.': 'Made with the clips you added.',
  'Rebuilt as a photo carousel with the photos you chose.':
    'Rebuilt as a photo carousel with the photos you chose.',
  'Change Drive folder': 'Change Drive folder',
  'Connect Google Drive': 'Connect Google Drive',
  'No archived files.': 'No archived files.',
  'No files match these filters.': 'No files match these filters.',
  'Already in the library': 'Already in the library',
  'Replace the current draft?': 'Replace the current draft?',
  'There is an unapplied draft by {name}. Restoring v{v} replaces it, and its changes are lost.':
    'There is an unapplied draft by {name}. Restoring v{v} replaces it, and its changes are lost.',
  'Review the draft first': 'Review the draft first',
  'Replace draft with v{v}': 'Replace draft with v{v}',
  'Keep my draft': 'Keep my draft',
  'First brand guide': 'First brand guide',
  'Added to the calendar on {day}. AMY is drafting it now.':
    'Added to the calendar on {day}. AMY is drafting it now.',
  '{channel} needs reconnecting before AMY can plan posts for it.':
    '{channel} needs reconnecting before AMY can plan posts for it.',
  'Resume the campaign to add ideas to the calendar.':
    'Resume the campaign to add ideas to the calendar.',
  'No free {channel} slot between {from} and {to}. Free a slot or change the campaign dates.':
    'No free {channel} slot between {from} and {to}. Free a slot or change the campaign dates.',
  'All campaigns': 'All campaigns',
  '{n} posts a week': '{n} posts a week',
  'Campaign chat': 'Campaign chat',
  'AMY needs an answer': 'AMY needs an answer',
  'Your answer': 'Your answer',
  'For example: closed 24–26 December, open 10–14 on 31 December.':
    'For example: closed 24–26 December, open 10–14 on 31 December.',
  'Thanks. AMY is preparing ideas with your answer.':
    'Thanks. AMY is preparing ideas with your answer.',
  'Send answer': 'Send answer',
  'Paused. AMY prepares no new posts for this campaign. Scheduled posts still go out.':
    'Paused. AMY prepares no new posts for this campaign. Scheduled posts still go out.',
  'Resume campaign': 'Resume campaign',
  'This campaign has ended. Published posts and their results stay here.':
    'This campaign has ended. Published posts and their results stay here.',
  'Next free slots': 'Next free slots',
  'none in these dates': 'none in these dates',
  'Review {n}': 'Review {n}',
  Ideas: 'Ideas',
  'AMY is suggesting more ideas.': 'AMY is suggesting more ideas.',
  'Resume the campaign first': 'Resume the campaign first',
  'AMY is reading your brief and brand guide v{v}…':
    'AMY is reading your brief and brand guide v{v}…',
  'Add to calendar': 'Add to calendar',
  'Not this one': 'Not this one',
  'In the calendar': 'In the calendar',
  'Bring back': 'Bring back',
  'No posts yet. Accepted ideas appear here and in the calendar.':
    'No posts yet. Accepted ideas appear here and in the calendar.',
  Brief: 'Brief',
  'Materials for AMY': 'Materials for AMY',
  'AMY writes with brand guide v{v}. Created by {name}.':
    'AMY writes with brand guide v{v}. Created by {name}.',
  'AMY tasks for this campaign': 'AMY tasks for this campaign',
  'Campaign paused': 'Campaign paused',
  'Pause campaign': 'Pause campaign',
  'End campaign': 'End campaign',
  'End “{name}”?': 'End “{name}”?',
  '{n} posts that are not approved yet will be cancelled and their slots freed.':
    '{n} posts that are not approved yet will be cancelled and their slots freed.',
  '{n} scheduled posts keep their schedule unless you stop them below.':
    '{n} scheduled posts keep their schedule unless you stop them below.',
  'Published posts and their results stay.': 'Published posts and their results stay.',
  'Also stop the {n} scheduled posts': 'Also stop the {n} scheduled posts',
  'Campaign ended': 'Campaign ended',
  'Campaign updated': 'Campaign updated',
  'The end date is before the start date.': 'The end date is before the start date.',
  'Start from tomorrow or later.': 'Start from tomorrow or later.',
  'Step {n} of {total}: {name}': 'Step {n} of {total}: {name}',
  'What is this campaign for?': 'What is this campaign for?',
  'Campaign name': 'Campaign name',
  'For example: Hot chocolate launch': 'For example: Hot chocolate launch',
  'A campaign with this name already exists.': 'A campaign with this name already exists.',
  'When and where?': 'When and where?',
  'No end date (always-on)': 'No end date (always-on)',
  Start: 'Start',
  End: 'End',
  Channels: 'Channels',
  '{status}: AMY can plan, but nothing is published until it is reconnected.':
    '{status}: AMY can plan, but nothing is published until it is reconnected.',
  'Choose at least one channel.': 'Choose at least one channel.',
  'Posts per week: {n}': 'Posts per week: {n}',
  'About {w} posts are needed, but only {f} channel slots are free in these dates. AMY fills what fits; free slots or extend the dates for more.':
    'About {w} posts are needed, but only {f} channel slots are free in these dates. AMY fills what fits; free slots or extend the dates for more.',
  'About {w} posts fit into {f} free channel slots between {from} and {to}.':
    'About {w} posts fit into {f} free channel slots between {from} and {to}.',
  'Tell AMY what matters': 'Tell AMY what matters',
  'What is new, who it is for, what guests should do. For example: our new hot chocolate, for families on weekends, come to the window seats.':
    'What is new, who it is for, what guests should do. For example: our new hot chocolate, for families on weekends, come to the window seats.',
  'A sentence or two is enough.': 'A sentence or two is enough.',
  'AMY also follows brand guide v{v}.': 'AMY also follows brand guide v{v}.',
  'Optional. Without materials AMY uses your Material bank.':
    'Optional. Without materials AMY uses your Material bank.',
  'Check and start': 'Check and start',
  Goal: 'Goal',
  Dates: 'Dates',
  Rhythm: 'Rhythm',
  'From the Material bank': 'From the Material bank',
  'AMY suggests ideas first. Nothing goes into the calendar until you accept an idea, and nothing is published before you approve it.':
    'AMY suggests ideas first. Nothing goes into the calendar until you accept an idea, and nothing is published before you approve it.',
  Next: 'Next',
  'Save changes': 'Save changes',
  'Save as draft': 'Save as draft',
  'Create and ask AMY for ideas': 'Create and ask AMY for ideas',
  'planned for {day}': 'planned for {day}',
  'Open draft': 'Open draft',
  'This campaign does not exist in this workspace.':
    'This campaign does not exist in this workspace.',
  Campaigns: 'Campaigns',
  'AMY tasks': 'AMY tasks',
  'Open campaign: {name}': 'Open campaign: {name}',
  '{n} published': '{n} published',
  '{n} scheduled': '{n} scheduled',
  '{n} to review': '{n} to review',
  '{n} new ideas': '{n} new ideas',
  'No campaigns yet. Start one and AMY suggests the first ideas.':
    'No campaigns yet. Start one and AMY suggests the first ideas.',
  'Everything you or your team asked AMY to do, from chat and campaigns. Demo: AMY’s work is simulated.':
    'Everything you or your team asked AMY to do, from chat and campaigns. Demo: AMY’s work is simulated.',
  'No tasks here.': 'No tasks here.',
  'Asked by {name}': 'Asked by {name}',
  'Planned for {day}': 'Planned for {day}',
  'Draft {n}': 'Draft {n}',
  'See ideas': 'See ideas',
  'Start now': 'Start now',
  'Cancel task': 'Cancel task',
  'Open in the AMY chat': 'Open in the AMY chat',
  'Launch a product': 'Launch a product',
  'A new drink, cake or menu item.': 'A new drink, cake or menu item.',
  'Seasonal menu': 'Seasonal menu',
  'A few weeks around a season or holiday.': 'A few weeks around a season or holiday.',
  'Event or opening hours': 'Event or opening hours',
  'One date to announce, remind and thank.': 'One date to announce, remind and thank.',
  'Get known locally': 'Get known locally',
  'Introduce the place and the people.': 'Introduce the place and the people.',
  'Everyday content': 'Everyday content',
  'No end date. Steady posts every week.': 'No end date. Steady posts every week.',
  'Dates and channels': 'Dates and channels',
  Check: 'Check',
  Planning: 'Planning',
  'Ideas ready': 'Ideas ready',
  Finished: 'Finished',
  Failed: 'Failed',
  'In progress': 'In progress',
  'Which days will you be closed or open shorter between 24 December and 1 January?':
    'Which days will you be closed or open shorter between 24 December and 1 January?',
  'Suggest ideas for “{name}”': 'Suggest ideas for “{name}”',
  'Make a TikTok from the latte art clips': 'Make a TikTok from the latte art clips',
  'TikTok needs reconnecting, so AMY could not prepare a TikTok version.':
    'TikTok needs reconnecting, so AMY could not prepare a TikTok version.',
  '{channel} needs reconnecting, so AMY could not prepare a {channel} version.':
    '{channel} needs reconnecting, so AMY could not prepare a {channel} version.',
  '{channel} is not connected for this workspace.':
    '{channel} is not connected for this workspace.',
  'No free {channel} slot in the next weeks. Free a slot or allow more posts per day.':
    'No free {channel} slot in the next weeks. Free a slot or allow more posts per day.',
  'Made {n} versions for {day}.': 'Made {n} versions for {day}.',
  'Suggested {n} ideas for “{name}”.': 'Suggested {n} ideas for “{name}”.',
  'Draft ready for {day}.': 'Draft ready for {day}.',
  'Noted. AMY will use this for new content.': 'Noted. AMY will use this for new content.',
  'I have {n} new ideas for “{name}”. Accept the ones you like and I will put them in the calendar.':
    'I have {n} new ideas for “{name}”. Accept the ones you like and I will put them in the calendar.',
  '{name}: {n} new ideas': '{name}: {n} new ideas',
  'I could not finish “{title}”: {channel} needs reconnecting. Reconnect it in Settings and press Retry on the task.':
    'I could not finish “{title}”: {channel} needs reconnecting. Reconnect it in Settings and press Retry on the task.',
  'There is no free {channel} slot for “{title}”. Free a slot in the calendar and press Retry.':
    'There is no free {channel} slot for “{title}”. Free a slot in the calendar and press Retry.',
  'Here is a draft for “{title}” on {channel}. Have a look when you have a moment.':
    'Here is a draft for “{title}” on {channel}. Have a look when you have a moment.',
  'Noted. I will keep this in mind for new content.':
    'Noted. I will keep this in mind for new content.',
  'Got it. I am noting this down.': 'Got it. I am noting this down.',
  '{name} created the campaign “{title}”.': '{name} created the campaign “{title}”.',
  '{name} answered AMY’s question for “{title}”.': '{name} answered AMY’s question for “{title}”.',
  '{name} paused the campaign “{title}”. AMY prepares no new posts for it.':
    '{name} paused the campaign “{title}”. AMY prepares no new posts for it.',
  '{name} resumed the campaign “{title}”.': '{name} resumed the campaign “{title}”.',
  '{name} ended the campaign “{title}”.': '{name} ended the campaign “{title}”.',
  'Accepted the idea': 'Accepted the idea',
  'First draft ready': 'First draft ready',
  'Drafted by AMY': 'Drafted by AMY',
  'Cancelled when the campaign ended': 'Cancelled when the campaign ended',
  'Stopped when the campaign ended': 'Stopped when the campaign ended',
  'The first draft from your accepted idea is ready for review.':
    'The first draft from your accepted idea is ready for review.',
  '{title}: first draft ready for review': '{title}: first draft ready for review',
  'Choose material for this campaign': 'Choose material for this campaign',
  'AMY is thinking…': 'AMY is thinking…',
  'Ask for more ideas': 'Ask for more ideas',
  'Show declined ideas ({n})': 'Show declined ideas ({n})',
  'Hide declined ideas': 'Hide declined ideas',
  'No new ideas waiting. Ask AMY for more when you need them.':
    'No new ideas waiting. Ask AMY for more when you need them.',
  'No ideas yet. Ask AMY for the first ones.': 'No ideas yet. Ask AMY for the first ones.',
  'Edit campaign': 'Edit campaign',
  'Chat with AMY': 'Chat with AMY',
  'Archived only': 'Archived only',
  'AMY stops suggesting it. You can restore it from “Archived only”.':
    'AMY stops suggesting it. You can restore it from “Archived only”.',
  'File name': 'File name',
  'Colour name': 'Colour name',
  'Idea sent. AMY is drafting it; follow it under AMY tasks.':
    'Idea sent. AMY is drafting it; follow it under AMY tasks.',
  'Add an idea': 'Add an idea',
  'Tell AMY in your own words. Nothing is published before you approve it.':
    'Tell AMY in your own words. Nothing is published before you approve it.',
  'Your idea': 'Your idea',
  'For example: Saturday coffee tasting with our new Ethiopian beans, 11–13, free for regulars.':
    'For example: Saturday coffee tasting with our new Ethiopian beans, 11–13, free for regulars.',
  'Suggested date': 'Suggested date',
  Campaign: 'Campaign',
  'No campaign': 'No campaign',
  '{channels} needs reconnecting. AMY makes the other versions and tells you which one is missing.':
    '{channels} needs reconnecting. AMY makes the other versions and tells you which one is missing.',
  'Task handed to the agency': 'Task handed to the agency',
  'Open tasks': 'Open tasks',
  'AMY is waiting for the client': 'AMY is waiting for the client',
  'Content creation is paused for this campaign. Resume it to add ideas.':
    'Content creation is paused for this campaign. Resume it to add ideas.',
  'Publishing paused. {n} scheduled posts are held.':
    'Publishing paused. {n} scheduled posts are held.',
  'Publishing resumed. {n} posts went back to the schedule; {b} stay held because their slot is taken.':
    'Publishing resumed. {n} posts went back to the schedule; {b} stay held because their slot is taken.',
  'Publishing resumed. {n} posts went back to the schedule.':
    'Publishing resumed. {n} posts went back to the schedule.',
  'Creation paused': 'Creation paused',
  'Publishing paused': 'Publishing paused',
  'Owner: {name}': 'Owner: {name}',
  'Waiting for your answer': 'Waiting for your answer',
  'Thanks. AMY continues with your answer.': 'Thanks. AMY continues with your answer.',
  'Handed to Hakusana. They reply in the conversation.':
    'Handed to Hakusana. They reply in the conversation.',
  'Hand to agency': 'Hand to agency',
  Plan: 'Plan',
  '{n} posts · {left} not drafted yet': '{n} posts · {left} not drafted yet',
  'Review the plan. Activating drafts the first two posts as samples; once you approve them, AMY drafts the rest in batches of {n}.':
    'Review the plan. Activating drafts the first two posts as samples; once you approve them, AMY drafts the rest in batches of {n}.',
  'Campaign active. AMY is drafting {n} sample posts.':
    'Campaign active. AMY is drafting {n} sample posts.',
  'Activate campaign': 'Activate campaign',
  'Samples: approve the {n} sample posts and AMY drafts the next batch automatically.':
    'Samples: approve the {n} sample posts and AMY drafts the next batch automatically.',
  'AMY is waiting: {n} posts are waiting for your review. The next batch starts when fewer than {limit} are waiting.':
    'AMY is waiting: {n} posts are waiting for your review. The next batch starts when fewer than {limit} are waiting.',
  'No automatic batches while content creation is paused.':
    'No automatic batches while content creation is paused.',
  'Next automatic batch: {day} · {n} posts': 'Next automatic batch: {day} · {n} posts',
  'AMY is drafting {n} posts now.': 'AMY is drafting {n} posts now.',
  'No free slots for a new batch.': 'No free slots for a new batch.',
  'Run it now (demo)': 'Run it now (demo)',
  Gaps: 'Gaps',
  '{from} – {to}: {have} of {need} posts planned': '{from} – {to}: {have} of {need} posts planned',
  'Fill with ideas': 'Fill with ideas',
  'Resume content creation first': 'Resume content creation first',
  Audience: 'Audience',
  'Product focus': 'Product focus',
  Polish: 'Polish',
  English: 'English',
  Accounts: 'Accounts',
  'Saved as a template. It appears in New campaign for this agency.':
    'Saved as a template. It appears in New campaign for this agency.',
  'Save as template': 'Save as template',
  Controls: 'Controls',
  'Content creation': 'Content creation',
  'New ideas, drafts and automatic batches. Pausing does not touch scheduled posts.':
    'New ideas, drafts and automatic batches. Pausing does not touch scheduled posts.',
  Publishing: 'Publishing',
  '{n} scheduled posts. Pausing holds them; nothing is published until you resume.':
    '{n} scheduled posts. Pausing holds them; nothing is published until you resume.',
  'Start from a template': 'Start from a template',
  Templates: 'Templates',
  Needs: 'Needs',
  Formats: 'Formats',
  'Start blank': 'Start blank',
  'Choose the goal yourself.': 'Choose the goal yourself.',
  'Choose at least one account.': 'Choose at least one account.',
  'Template “{name}” needs': 'Template “{name}” needs',
  'For example: families nearby, weekends': 'For example: families nearby, weekends',
  'For example: hot chocolate, apple cake': 'For example: hot chocolate, apple cake',
  'Choose at least one language.': 'Choose at least one language.',
  'Help me plan this': 'Help me plan this',
  'Proposed plan: {n} posts': 'Proposed plan: {n} posts',
  'Discard the plan': 'Discard the plan',
  'AMY understood': 'AMY understood',
  'Next step': 'Next step',
  'Where this post came from': 'Where this post came from',
  'From {name}’s request': 'From {name}’s request',
  'See the task': 'See the task',
  Waiting: 'Waiting',
  'With agency': 'With agency',
  'Plan ready': 'Plan ready',
  'Needs you': 'Needs you',
  'Content creation paused. Scheduled posts still publish.':
    'Content creation paused. Scheduled posts still publish.',
  'Content creation resumed.': 'Content creation resumed.',
  'Resume creation': 'Resume creation',
  'Pause creation': 'Pause creation',
  'Pause publishing': 'Pause publishing',
  'Add a photo or video (optional)': 'Add a photo or video (optional)',
  'AMY uses the first free slot from this day.': 'AMY uses the first free slot from this day.',
  'Taken from your text. Change it if needed.': 'Taken from your text. Change it if needed.',
  'Leave empty and AMY picks the next free slot.': 'Leave empty and AMY picks the next free slot.',
  'Create with this plan': 'Create with this plan',
  'You review this plan on the campaign page before anything is drafted. Activation drafts two sample posts first.':
    'You review this plan on the campaign page before anything is drafted. Activation drafts two sample posts first.',
  'Product launch': 'Product launch',
  'Tease, launch day, how it is made, last chance.':
    'Tease, launch day, how it is made, last chance.',
  'Product name': 'Product name',
  'Launch date': 'Launch date',
  'One photo of the product': 'One photo of the product',
  Event: 'Event',
  'Save the date, what to expect, same-day reminder, thank you.':
    'Save the date, what to expect, same-day reminder, thank you.',
  'Event name': 'Event name',
  'Date and time': 'Date and time',
  'Photo from a past event': 'Photo from a past event',
  'Team story': 'Team story',
  'One person, one favourite drink, one short story.':
    'One person, one favourite drink, one short story.',
  'Person and role': 'Person and role',
  'A photo of them': 'A photo of them',
  'Their favourite drink': 'Their favourite drink',
  Announcement: 'Announcement',
  'Clear news: opening hours, closures, price changes.':
    'Clear news: opening hours, closures, price changes.',
  'From when': 'From when',
  'Who it affects': 'Who it affects',
  'What is new': 'What is new',
  'One photo': 'One photo',
  'Plan the holiday opening hours posts': 'Plan the holiday opening hours posts',
  'Posts on Instagram and Facebook announcing the holiday opening hours.':
    'Posts on Instagram and Facebook announcing the holiday opening hours.',
  'Answer the question so AMY can write the posts.':
    'Answer the question so AMY can write the posts.',
  'AMY writes the plan with your answer.': 'AMY writes the plan with your answer.',
  'Plan “{name}”': 'Plan “{name}”',
  'Plan ready: {n} posts for “{name}”.': 'Plan ready: {n} posts for “{name}”.',
  'The plan for “{name}” is ready: {n} posts. Review it and activate the campaign when it looks right.':
    'The plan for “{name}” is ready: {n} posts. Review it and activate the campaign when it looks right.',
  '{name}: plan ready for review': '{name}: plan ready for review',
  '{n} versions ready for {day}.': '{n} versions ready for {day}.',
  'Not made for {channels}: reconnect the account or free a slot, then ask again.':
    'Not made for {channels}: reconnect the account or free a slot, then ask again.',
  'You are welcome! Tell me whenever you want me to prepare something.':
    'You are welcome! Tell me whenever you want me to prepare something.',
  'Noted. If you want me to make a post or ideas from this, just say so.':
    'Noted. If you want me to make a post or ideas from this, just say so.',
  'Thanks for the idea! I am turning it into a draft.':
    'Thanks for the idea! I am turning it into a draft.',
  'A {channel} post about “{title}”{when}.': 'A post on {channel} about “{title}”{when}.',
  '{channels} post about “{title}”{when}{campaign}.':
    '{channels} post about “{title}”{when}{campaign}.',
  'New ideas for “{name}”.': 'New ideas for “{name}”.',
  'AMY suggests ideas; you choose which go into the calendar.':
    'AMY suggests ideas; you choose which go into the calendar.',
  'AMY drafts it in the first free slot, then asks you to review.':
    'AMY drafts it in the first free slot, then asks you to review.',
  'AMY drafts one version per channel, then asks you to review.':
    'AMY drafts one version per channel, then asks you to review.',
  'Hakusana will pick this up and reply in this conversation.':
    'Hakusana will pick this up and reply in this conversation.',
  '{name} answered AMY: {text}': '{name} answered AMY: {text}',
  '{name} handed a task to Hakusana: {text}': '{name} handed a task to Hakusana: {text}',
  '{name} paused content creation for “{title}”. Scheduled posts still publish.':
    '{name} paused content creation for “{title}”. Scheduled posts still publish.',
  '{name} resumed content creation for “{title}”.':
    '{name} resumed content creation for “{title}”.',
  '{name} paused publishing for “{title}”. Scheduled posts are held.':
    '{name} paused publishing for “{title}”. Scheduled posts are held.',
  '{name} resumed publishing for “{title}”.': '{name} resumed publishing for “{title}”.',
  'AMY drafted {n} sample posts for “{title}”. Approve them and AMY drafts the rest in batches.':
    'AMY drafted {n} sample posts for “{title}”. Approve them and AMY drafts the rest in batches.',
  'Samples approved. AMY drafted the next {n} posts for “{title}” automatically.':
    'Samples approved. AMY drafted the next {n} posts for “{title}” automatically.',
  'AMY drafted the next {n} posts for “{title}”.': 'AMY drafted the next {n} posts for “{title}”.',
  'Held: campaign publishing paused': 'Held: campaign publishing paused',
  'Publishing resumed': 'Publishing resumed',
  'Sample post from the campaign plan': 'Sample post from the campaign plan',
  'Drafted in an automatic batch': 'Drafted in an automatic batch',
  'Drafted from {name}’s request': 'Drafted from {name}’s request',
  '{channel} is no longer one of this campaign’s channels. Add it back in Edit, or decline the idea.':
    '{channel} is no longer one of this campaign’s channels. Add it back in Edit, or decline the idea.',
  '{channel} is no longer in this campaign.': '{channel} is no longer in this campaign.',
  'This is the chat for “{name}”. Ask me anything about the campaign here.':
    'This is the chat for “{name}”. Ask me anything about the campaign here.',
  'Cancelled when its campaign ended. It will not be published.':
    'Cancelled when its campaign ended. It will not be published.',
  'Moved “{title}” to {when}.': 'Moved “{title}” to {when}.',
  'Moved “{title}”. Its approval is kept.': 'Moved “{title}”. Its approval is kept.',
  'Move undone': 'Move undone',
  Undo: 'Undo',
  'Tip: drag a post to a free slot on the same channel to move it.':
    'Tip: drag a post to a free slot on the same channel to move it.',
  'Selected posts': 'Selected posts',
  '{n} selected': '{n} selected',
  'Approved {n} posts. They are scheduled.': 'Approved {n} posts. They are scheduled.',
  'Approve {n}': 'Approve {n}',
  'Only {name} can approve': 'Only {name} can approve',
  'Review one by one': 'Review one by one',
  Clear: 'Clear',
  'Select all {n} waiting for review': 'Select all {n} waiting for review',
  'Select {post}': 'Select {post}',
  'Preview as on {channel}': 'Preview as on {channel}',
  'Original sound': 'Original sound',
  'Company page · now': 'Company page · now',
  'Just now · public': 'Just now · public',
  Like: 'Like',
  Repost: 'Repost',
  Share: 'Share',
  'Too long for {channel}: {n} of {max} characters.':
    'Too long for {channel}: {n} of {max} characters.',
  '{n} characters · {channel} shows about {fold} before “more”. Simplified preview.':
    '{n} characters · {channel} shows about {fold} before “more”. Simplified preview.',
  Post: 'Post',
  'As on {channel}': 'As on {channel}',
  'Move to another day': 'Move to another day',
  Move: 'Move',
  'Choose a new time': 'Choose a new time',
  'Published to {account}.': 'Published to {account}.',
  '{account} is still not connected.': '{account} is still not connected.',
  'Publish now': 'Publish now',
  'Invite sent at {time}': 'Invite sent at {time}',
  'Invite sent to {name} (simulated)': 'Invite sent to {name} (simulated)',
  '{name} connected the account (simulated). You can publish now.':
    '{name} connected the account (simulated). You can publish now.',
  'Simulate: connected': 'Simulate: connected',
  'Moved to {when} at {time}.': 'Moved to {when} at {time}.',
  'Move “{title}”': 'Move “{title}”',
  'now {when} at {time}': 'now {when} at {time}',
  'One post per channel per day. Days with a post on {channel} are taken.':
    'One post per channel per day. Days with a post on {channel} are taken.',
  'Taken by “{title}”': 'Taken by “{title}”',
  Current: 'Current',
  Free: 'Free',
  Time: 'Time',
  'Only the time changes. The post still needs your review.':
    'Only the time changes. The post still needs your review.',
  'Move to {when}': 'Move to {when}',
  less: 'less',
  'That slot was just taken. Choose another day.': 'That slot was just taken. Choose another day.',
  'Choose a day after today.': 'Choose a day after today.',
  'This post can no longer be moved.': 'This post can no longer be moved.',
  'That slot is taken. One post per channel per day.':
    'That slot is taken. One post per channel per day.',
  'The approval is kept, and the post is scheduled again at the new time.':
    'The approval is kept, and the post is scheduled again at the new time.',
  'The approval is kept. Only the time changes.': 'The approval is kept. Only the time changes.',
  'Moved from {from} to {to}': 'Moved from {from} to {to}',
  '{name} moved “{title}” ({channel}) from {from} to {to}.':
    '{name} moved “{title}” ({channel}) from {from} to {to}.',
  'Published again to {account}': 'Published again to {account}',
  '“{title}” is now published to {account} too.': '“{title}” is now published to {account} too.',
  '{asked} was already full on {full}, so AMY used the next free day: {where}. Use Move on a draft to change it.':
    '{asked} was already full on {full}, so AMY used the next free day: {where}. Use Move on a draft to change it.',
  'Drafts ready: {where}.': 'Drafts ready: {where}.',
  '{day} is already full on {channels}. AMY uses the next free day there, or pick another date.':
    '{day} is already full on {channels}. AMY uses the next free day there, or pick another date.',
  'New post': 'New post',
  Day: 'Day',
  Title: 'Title',
  Save: 'Save',
  taken: 'taken',
  'Edit {word}': 'Edit {word}',
  'Add a post to the plan': 'Add a post to the plan',
  'This queue is done': 'This queue is done',
  '{n} other posts in {ws} are still waiting for review.':
    '{n} other posts in {ws} are still waiting for review.',
  'Review the other {n}': 'Review the other {n}',
  '{day} is already full on {channels}. AMY uses up to three days before, or pick another date.':
    '{day} is already full on {channels}. AMY uses up to three days before, or pick another date.',
  'New time suggested by the client': 'New time suggested by the client',
  'Checking result': 'Checking result',
  'New time suggested': 'New time suggested',
  'Approve these {n} versions?': 'Approve these {n} versions?',
  '{network} needs reconnecting: approved, but it waits until reconnected':
    '{network} needs reconnecting: approved, but it waits until reconnected',
  'Not included': 'Not included',
  'No longer waiting for review ({status})': 'No longer waiting for review ({status})',
  'You skipped {n} in this queue. They still need a decision.':
    'You skipped {n} in this queue. They still need a decision.',
  'Back to the {n} you skipped': 'Back to the {n} you skipped',
  '{name} suggests {when} at {time}': '{name} suggests {when} at {time}',
  'New time applied.': 'New time applied.',
  'That slot is taken now. Choose another time with Move.':
    'That slot is taken now. Choose another time with Move.',
  Apply: 'Apply',
  'Kept the current time.': 'Kept the current time.',
  'Keep current time': 'Keep current time',
  'Suggestion withdrawn.': 'Suggestion withdrawn.',
  Withdraw: 'Withdraw',
  'Skip for now': 'Skip for now',
  'Nothing is needed from you.': 'Nothing is needed from you.',
  'One account needs its owner to connect it. The others are done and will not be posted again.':
    'One account needs its owner to connect it. The others are done and will not be posted again.',
  'AMY is confirming one result. You do not need to do anything.':
    'AMY is confirming one result. You do not need to do anything.',
  'Open published post: not available in the demo':
    'Open published post: not available in the demo',
  'Checked: it was published. Nothing was posted twice.':
    'Checked: it was published. Nothing was posted twice.',
  'Check result': 'Check result',
  'Suggestion sent. Hakusana confirms the new time; until then the post keeps its current time.':
    'Suggestion sent. Hakusana confirms the new time; until then the post keeps its current time.',
  'Note for Hakusana (optional)': 'Note for Hakusana (optional)',
  'For example: the tasting moved to Friday': 'For example: the tasting moved to Friday',
  'Your agency moves posts. They get your suggestion and confirm it; the post keeps its current time until then.':
    'Your agency moves posts. They get your suggestion and confirm it; the post keeps its current time until then.',
  'Suggest a new time': 'Suggest a new time',
  'Suggest a new time for “{title}”': 'Suggest a new time for “{title}”',
  'Suggest {when}': 'Suggest {when}',
  'Apply it, or keep the current time.': 'Apply it, or keep the current time.',
  'Waiting for Hakusana to confirm. The post keeps its current time until then.':
    'Waiting for Hakusana to confirm. The post keeps its current time until then.',
  'Almost done': 'Almost done',
  '{asked} was already full on {full}, so AMY used an earlier free day: {where}. Use Move on a draft to change it.':
    '{asked} was already full on {full}, so AMY used an earlier free day: {where}. Use Move on a draft to change it.',
  'Not made for {channels}: no free slot on or up to three days before {asked}. Free a slot, then ask again.':
    'Not made for {channels}: no free slot on or up to three days before {asked}. Free a slot, then ask again.',
  'No free {channel} slot on {asked} or the three days before. Free a slot and press Retry.':
    'No free {channel} slot on {asked} or the three days before. Free a slot and press Retry.',
  'Suggested a new time: {when}': 'Suggested a new time: {when}',
  '{name} suggested moving “{title}” ({channel}) to {when}. Hakusana will confirm.':
    '{name} suggested moving “{title}” ({channel}) to {when}. Hakusana will confirm.',
  'Declined the suggested time': 'Declined the suggested time',
  '{name} kept “{title}” at its current time.': '{name} kept “{title}” at its current time.',
  'Checked {account}: it was published, nothing was posted twice':
    'Checked {account}: it was published, nothing was posted twice',
  'Instagram did not confirm in time. AMY checks whether it went out before trying again.':
    'Instagram did not confirm in time. AMY checks whether it went out before trying again.',
  '{day} is already full on {channels}.': '{day} is already full on {channels}.',
  earlier: 'earlier',
  'next free {day}, after the date': 'next free {day}, after the date',
  'no free day soon': 'no free day soon',
  'OK to post after the date where needed': 'OK to post after the date where needed',
  'Without this, AMY asks you before posting anything after the date.':
    'Without this, AMY asks you before posting anything after the date.',
  '{asked} and the three days before are full on {channels}. Next free: {next}. Post then, or only on the channels that fit?':
    '{asked} and the three days before are full on {channels}. Next free: {next}. Post then, or only on the channels that fit?',
  'Use the next free days': 'Use the next free days',
  'Only the channels that fit': 'Only the channels that fit',
  'Choose below, or pick another date with Add an idea.':
    'Choose below, or pick another date with Add an idea.',
  '{asked} is full on {channels}. Should I use the next free day ({next}) or skip those channels?':
    '{asked} is full on {channels}. Should I use the next free day ({next}) or skip those channels?',
  'As you chose, {full} goes out after {asked}: {where}. Use Move on a draft to change it.':
    'As you chose, {full} goes out after {asked}: {where}. Use Move on a draft to change it.',
  'AMY drafts it with your choice.': 'AMY drafts it with your choice.',
  '{name} chose the next free days for “{title}”.':
    '{name} chose the next free days for “{title}”.',
  '{name} chose only the channels that fit for “{title}”.':
    '{name} chose only the channels that fit for “{title}”.',
  'Needs a new time': 'Needs a new time',
  'Pause all publishing for {ws}?': 'Pause all publishing for {ws}?',
  'Nothing is published until you resume. Drafts and reviews continue. Demo clock: {time} today.':
    'Nothing is published until you resume. Drafts and reviews continue. Demo clock: {time} today.',
  '{n} scheduled posts would wait': '{n} scheduled posts would wait',
  'Do not publish late': 'Do not publish late',
  '…and {n} more': '…and {n} more',
  'After resuming, posts missed by up to two hours go out late, unless marked Do not publish late. Anything later needs a new time.':
    'After resuming, posts missed by up to two hours go out late, unless marked Do not publish late. Anything later needs a new time.',
  'Resume time (demo clock; the pause started at {time})':
    'Resume time (demo clock; the pause started at {time})',
  'Nothing was missed during the pause.': 'Nothing was missed during the pause.',
  'Missed during the pause': 'Missed during the pause',
  'Goes out now, {m} minutes late': 'Goes out now, {m} minutes late',
  'Marked Do not publish late: needs a new time': 'Marked Do not publish late: needs a new time',
  'More than two hours late: needs a new time': 'More than two hours late: needs a new time',
  'Publishing resumed. {n} posts need a new time.':
    'Publishing resumed. {n} posts need a new time.',
  'Publishing resumed.': 'Publishing resumed.',
  'Resume at {time}': 'Resume at {time}',
  '{title}, slide {i} of {n}': '{title}, slide {i} of {n}',
  'Version history ({n})': 'Version history ({n})',
  'Version {n} · current': 'Version {n} · current',
  'Change: {note}': 'Change: {note}',
  'Different photo': 'Different photo',
  'Its time passed and it was not published. Choose or suggest a new time; nothing is rebooked automatically.':
    'Its time passed and it was not published. Choose or suggest a new time; nothing is rebooked automatically.',
  'Approved after its time; moved to the next free slot: {when}':
    'Approved after its time; moved to the next free slot: {when}',
  'Approved after its time; no free slot, needs a new time':
    'Approved after its time; no free slot, needs a new time',
  '{name} approved “{title}” after its time. It moved to {when}.':
    '{name} approved “{title}” after its time. It moved to {when}.',
  '{name} approved “{title}” after its time. It needs a new time.':
    '{name} approved “{title}” after its time. It needs a new time.',
  'Published {m} minutes late after the pause': 'Published {m} minutes late after the pause',
  'Missed during the pause; marked do not publish late':
    'Missed during the pause; marked do not publish late',
  'Missed during the pause by more than two hours':
    'Missed during the pause by more than two hours',
  '{name} resumed publishing at {time}.': '{name} resumed publishing at {time}.',
  'AMY is still drafting it. Review it when the draft is ready.':
    'AMY is still drafting it. Review it when the draft is ready.',
  'It needs material first, so there is nothing to approve yet.':
    'It needs material first, so there is nothing to approve yet.',
  '{channel} already has a post on {day}. Choose another day.':
    '{channel} already has a post on {day}. Choose another day.',
  '{n} planned posts clash with the calendar. Edit their day before activating.':
    '{n} planned posts clash with the calendar. Edit their day before activating.',
  '{n} planned posts for “{title}” clash with posts already in the calendar. Edit their day in the plan.':
    '{n} planned posts for “{title}” clash with posts already in the calendar. Edit their day in the plan.',
  'All statuses': 'All statuses',
  'All accounts': 'All accounts',
  'Clear filters': 'Clear filters',
  'Showing {n} posts that match': 'Showing {n} posts that match',
  'Current day · change the time': 'Current day · change the time',
  'Moved. It was on {when} at {time}.': 'Moved. It was on {when} at {time}.',
  'The original slot is taken now.': 'The original slot is taken now.',
  'Waiting for confirmation': 'Waiting for confirmation',
  'Connected now. You can publish to this account.':
    'Connected now. You can publish to this account.',
  'The owner approves posts, stops posts and manages people and accounts.':
    'The owner approves posts, stops posts and manages people and accounts.',
  'Toggle post approvals for {name}': 'Toggle post approvals for {name}',
  'Toggle stopping posts for {name}': 'Toggle stopping posts for {name}',
  '{name} no longer has access.': '{name} no longer has access.',
  'Remove access': 'Remove access',
  Invitations: 'Invitations',
  'Invitation expired · sent {when} by {name}': 'Invitation expired · sent {when} by {name}',
  'Invited {when} by {name} · expires in 7 days': 'Invited {when} by {name} · expires in 7 days',
  'Invitation sent again to {email} (simulated)': 'Invitation sent again to {email} (simulated)',
  Resend: 'Resend',
  'Invitation withdrawn': 'Invitation withdrawn',
  '{name} accepted the invitation (simulated)': '{name} accepted the invitation (simulated)',
  'Simulate: accepted': 'Simulate: accepted',
  'Who can do what': 'Who can do what',
  Person: 'Person',
  'Review and comment': 'Review and comment',
  Approve: 'Approve',
  'Stop scheduled posts': 'Stop scheduled posts',
  'Move posts': 'Move posts',
  'People and accounts': 'People and accounts',
  'Suggests a time': 'Suggests a time',
  'Accounts only': 'Accounts only',
  'Clients approve their own posts. The agency prepares, moves and stops posts, and helps with accounts.':
    'Clients approve their own posts. The agency prepares, moves and stops posts, and helps with accounts.',
  'Your own choices for {ws}. Others in the workspace choose theirs.':
    'Your own choices for {ws}. Others in the workspace choose theirs.',
  When: 'When',
  'Always shown in the app': 'Always shown in the app',
  '{event} by {channel}': '{event} by {channel}',
  'Quiet hours: no phone notifications 21:00–07:00, except problems with posts going out today':
    'Quiet hours: no phone notifications 21:00–07:00, except problems with posts going out today',
  'Your agency': 'Your agency',
  'Your main contact': 'Your main contact',
  'Usually replies within one working day': 'Usually replies within one working day',
  'No main contact is assigned yet.': 'No main contact is assigned yet.',
  'Staff assigned to {ws}': 'Staff assigned to {ws}',
  'Agency only. Assigned staff see this workspace and its tasks; the main contact is shown to the client.':
    'Agency only. Assigned staff see this workspace and its tasks; the main contact is shown to the client.',
  'Main contact': 'Main contact',
  'Make main contact': 'Make main contact',
  '{email} already has access or a pending invitation.':
    '{email} already has access or a pending invitation.',
  'Invitation sent to {email} (simulated). It expires in 7 days.':
    'Invitation sent to {email} (simulated). It expires in 7 days.',
  'Full name': 'Full name',
  'What can they do?': 'What can they do?',
  'Review posts, comment and request changes': 'Review posts, comment and request changes',
  'Approve posts for publishing': 'Approve posts for publishing',
  'They get an email with a link that works for 7 days. You can change these permissions later.':
    'They get an email with a link that works for 7 days. You can change these permissions later.',
  'Connected by': 'Connected by',
  'Connected on': 'Connected on',
  'Access expires': 'Access expires',
  'Upcoming posts on this account ({n})': 'Upcoming posts on this account ({n})',
  'Nothing planned for this account.': 'Nothing planned for this account.',
  'Access expired. Only {name} can reconnect, because the network asks the account owner to log in.':
    'Access expired. Only {name} can reconnect, because the network asks the account owner to log in.',
  'A personal profile can only be connected by its owner, {name}. Send them an invitation to connect.':
    'A personal profile can only be connected by its owner, {name}. Send them an invitation to connect.',
  'Not connected. Connect it to publish here.': 'Not connected. Connect it to publish here.',
  'AMY publishes only what you approve. It never posts in your name without an approved post.':
    'AMY publishes only what you approve. It never posts in your name without an approved post.',
  '{n} upcoming posts on this account keep their approval but wait until it is connected again. Nothing is deleted.':
    '{n} upcoming posts on this account keep their approval but wait until it is connected again. Nothing is deleted.',
  '{account} disconnected. {n} scheduled posts wait.':
    '{account} disconnected. {n} scheduled posts wait.',
  'A personal LinkedIn is connected by its owner. Invite them from Settings › People, or use Invite to connect on the profile.':
    'A personal LinkedIn is connected by its owner. Invite them from Settings › People, or use Invite to connect on the profile.',
  'Posts ready for review': 'Posts ready for review',
  'When AMY has a draft or a new version for you.':
    'When AMY has a draft or a new version for you.',
  'Requested changes are ready': 'Requested changes are ready',
  'When a version you asked to change comes back.':
    'When a version you asked to change comes back.',
  'When a post goes out.': 'When a post goes out.',
  'Something needs you': 'Something needs you',
  'A failed or partial publication, missing material or a question from AMY.':
    'A failed or partial publication, missing material or a question from AMY.',
  'Connection problems': 'Connection problems',
  'An account needs reconnecting.': 'An account needs reconnecting.',
  'Weekly summary': 'Weekly summary',
  'Monday morning: what went out and what is planned.':
    'Monday morning: what went out and what is planned.',
  'In the app': 'In the app',
  Phone: 'Phone',
  'Account manager': 'Account manager',
  'Content specialist': 'Content specialist',
  Designer: 'Designer',
  Expired: 'Expired',
  Invited: 'Invited',
  '{name} invited {person} as a contributor.': '{name} invited {person} as a contributor.',
  '{name} removed {person} from the workspace.': '{name} removed {person} from the workspace.',
  '{name} disconnected {account} ({network}). {n} scheduled posts wait until it is connected again.':
    '{name} disconnected {account} ({network}). {n} scheduled posts wait until it is connected again.',
  'Approved post needs a new time': 'Approved post needs a new time',
  'No posts match these filters': 'No posts match these filters',
  'Other posts this week are hidden by the filters.':
    'Other posts this week are hidden by the filters.',
  'Taken · hidden by filters': 'Taken · hidden by filters',
  'The account is connected now. Publish it there; the others will not be posted again.':
    'The account is connected now. Publish it there; the others will not be posted again.',
  '1 + 1 Reel/Story': '1 + 1 Reel/Story',
  '1–{d} November': '1–{d} November',
  'A personal LinkedIn profile belongs to one person, so only they can connect it. Choose who; they get a link that does nothing except connect their profile to {ws}.':
    'A personal LinkedIn profile belongs to one person, so only they can connect it. Choose who; they get a link that does nothing except connect their profile to {ws}.',
  'AI connected. AMY can draft with {provider} now.':
    'AI connected. AMY can draft with {provider} now.',
  'AI connection': 'AI connection',
  'AI is connected for {ws}. {owner} has been told. You can close this page.':
    'AI is connected for {ws}. {owner} has been told. You can close this page.',
  'AI key removed. AMY stops drafting until a key is connected.':
    'AI key removed. AMY stops drafting until a key is connected.',
  'AI tasks (drafts and revisions)': 'AI tasks (drafts and revisions)',
  'AMY cannot read private messages or change your password.':
    'AMY cannot read private messages or change your password.',
  'AMY checks the key straight away and tells you what to do if something is missing.':
    'AMY checks the key straight away and tells you what to do if something is missing.',
  'AMY drafts the first posts for {date}; you review them before anything is scheduled.':
    'AMY drafts the first posts for {date}; you review them before anything is scheduled.',
  'AMY made {n} sample posts with your brand kit. Approve them or ask for changes; this shows AMY what you like.':
    'AMY made {n} sample posts with your brand kit. Approve them or ask for changes; this shows AMY what you like.',
  'AMY needs your own AI key to draft posts. Your provider bills you separately from AMY.':
    'AMY needs your own AI key to draft posts. Your provider bills you separately from AMY.',
  'AMY only states facts from here, for example opening hours in a post. The brand kit links to these details instead of keeping its own copy.':
    'AMY only states facts from here, for example opening hours in a post. The brand kit links to these details instead of keeping its own copy.',
  'AMY stops drafting new posts and revisions. Scheduled and approved posts still publish. You can connect a key again at any time.':
    'AMY stops drafting new posts and revisions. Scheduled and approved posts still publish. You can connect a key again at any time.',
  'Accounts you manage on {network}:': 'Accounts you manage on {network}:',
  'Activate the plan': 'Activate the plan',
  'Activated on {date}.': 'Activated on {date}.',
  'Activated on {date}': 'Activated on {date}',
  'Add a payment method at {provider}, then test again. Nothing else needs changing.':
    'Add a payment method at {provider}, then test again. Nothing else needs changing.',
  'All set': 'All set',
  Allow: 'Allow',
  'Allow AMY to use your {network} account?': 'Allow AMY to use your {network} account?',
  'Already connected to {ws}': 'Already connected to {ws}',
  'An API key lets AMY use your own AI account. Your AI provider bills you separately from AMY.':
    'An API key lets AMY use your own AI account. Your AI provider bills you separately from AMY.',
  'Audience, products, opening hours and contacts live in one place, Business details, so they are never out of step.':
    'Audience, products, opening hours and contacts live in one place, Business details, so they are never out of step.',
  'Back to the owner’s view': 'Back to the owner’s view',
  'Before you can activate': 'Before you can activate',
  'Brand kit': 'Brand kit',
  'Business details saved. AMY uses them in new drafts.':
    'Business details saved. AMY uses them in new drafts.',
  Cadence: 'Cadence',
  'Can edit brand drafts': 'Can edit brand drafts',
  'Can publish': 'Can publish',
  'Choose a person': 'Choose a person',
  'Choose account': 'Choose account',
  'Choose another model above and test again.': 'Choose another model above and test again.',
  Closed: 'Closed',
  'Closing time must be after opening time.': 'Closing time must be after opening time.',
  Connect: 'Connect',
  'Connect AI for {ws}': 'Connect AI for {ws}',
  'Connect AI so AMY can draft.': 'Connect AI so AMY can draft.',
  'Connect an account': 'Connect an account',
  'Connect another account': 'Connect another account',
  'Connect at least one social account.': 'Connect at least one social account.',
  'Connect to workspace {ws}': 'Connect to workspace {ws}',
  'Connect-only invitation sent to {name} (simulated)':
    'Connect-only invitation sent to {name} (simulated)',
  'Connected by {name} · last test {when}': 'Connected by {name} · last test {when}',
  'Connected to {provider} ({model}) by {name}. Last test {when}.':
    'Connected to {provider} ({model}) by {name}. Last test {when}.',
  Copy: 'Copy',
  'Create a new key': 'Create a new key',
  'Daily digest email at 08:00 instead of one email per post':
    'Daily digest email at 08:00 instead of one email per post',
  Date: 'Date',
  'Date, e.g. 31 Dec': 'Date, e.g. 31 Dec',
  'Dates, not a balance: each date can be used once per channel, and only on that date.':
    'Dates, not a balance: each date can be used once per channel, and only on that date.',
  'Demo outcome of the test': 'Demo outcome of the test',
  'Demo: do not paste a real key. Nothing leaves this browser. A real setup checks the key with {provider}.':
    'Demo: do not paste a real key. Nothing leaves this browser. A real setup checks the key with {provider}.',
  'Discard changes': 'Discard changes',
  'Each channel can publish one post per day. Unused days do not carry over, so a quiet week never means extra posts today. Extra slots for a format, such as a Story, are set by Hakusana; none are set for this workspace.':
    'Each channel can publish one post per day. Unused days do not carry over, so a quiet week never means extra posts today. Extra slots for a format, such as a Story, are set by Hakusana; none are set for this workspace.',
  'Each permission is separate: approving posts does not include stopping them or publishing a new brand version. Clients approve their own posts; the agency prepares, moves and stops posts, and helps with accounts.':
    'Each permission is separate: approving posts does not include stopping them or publishing a new brand version. Clients approve their own posts; the agency prepares, moves and stops posts, and helps with accounts.',
  'Edit brand drafts': 'Edit brand drafts',
  'Edit business details': 'Edit business details',
  'Estimate for 30 posts a month: about 90 AI requests (a draft and two revisions each) of around 2,000 tokens, so roughly 180,000 tokens. On a mid-size model that is usually under US$3 a month. Images and video are not included. Prices checked {date}; your provider’s bill shows the real amount.':
    'Estimate for 30 posts a month: about 90 AI requests (a draft and two revisions each) of around 2,000 tokens, so roughly 180,000 tokens. On a mid-size model that is usually under US$3 a month. Images and video are not included. Prices checked {date}; your provider’s bill shows the real amount.',
  'Estimated cost': 'Estimated cost',
  'Every step is done. You can open any of them again from the list.':
    'Every step is done. You can open any of them again from the list.',
  'Exception date': 'Exception date',
  'Exceptions (holidays, events, closures)': 'Exceptions (holidays, events, closures)',
  'Finish setting up · {n} of {total} done': 'Finish setting up · {n} of {total} done',
  'First batch': 'First batch',
  'Fix the highlighted fields first.': 'Fix the highlighted fields first.',
  'For {ws}': 'For {ws}',
  'Future days free': 'Future days free',
  'Future days reserved': 'Future days reserved',
  'Helper view · demo': 'Helper view · demo',
  'Hi {name}, {owner} uses AMY to prepare social media posts. Please connect their AI account: the link opens one short step with instructions. You will not see their posts or settings.':
    'Hi {name}, {owner} uses AMY to prepare social media posts. Please connect their AI account: the link opens one short step with instructions. You will not see their posts or settings.',
  'How this is estimated: tokens times the provider’s example list price for this model (US$ {pin} per million tokens in, US$ {pout} out, checked 3 Nov 2026). Providers bill in US dollars; your provider’s invoice is the real amount.':
    'How this is estimated: tokens times the provider’s example list price for this model (US$ {pin} per million tokens in, US$ {pout} out, checked 3 Nov 2026). Providers bill in US dollars; your provider’s invoice is the real amount.',
  Illustration: 'Illustration',
  'Illustration of a key page': 'Illustration of a key page',
  'Image and video rendering and storage are part of your AMY plan and are not on this list or on your AI bill.':
    'Image and video rendering and storage are part of your AMY plan and are not on this list or on your AI bill.',
  'Interface language': 'Interface language',
  'Invitation preview': 'Invitation preview',
  'Invitation sent to {email} (simulated)': 'Invitation sent to {email} (simulated)',
  'Invitation sent to {email} at {when}. You can carry on with the other steps.':
    'Invitation sent to {email} at {when}. You can carry on with the other steps.',
  'Invite a helper to connect AI': 'Invite a helper to connect AI',
  'It may be incomplete or deleted. Create a new key named AMY, copy it in full, and test again.':
    'It may be incomplete or deleted. Create a new key named AMY, copy it in full, and test again.',
  Key: 'Key',
  'Last 7 days': 'Last 7 days',
  'Last updated by {name} on {date}': 'Last updated by {name} on {date}',
  'Manage in Settings': 'Manage in Settings',
  Model: 'Model',
  'No AI account is connected yet, so there is no usage to show. It appears here after you connect AI.':
    'No AI account is connected yet, so there is no usage to show. It appears here after you connect AI.',
  'No AI connected': 'No AI connected',
  'No exceptions yet.': 'No exceptions yet.',
  'No slot left on this day': 'No slot left on this day',
  'November at a glance': 'November at a glance',
  'Only {name} can connect AI.': 'Only {name} can connect AI.',
  'Only {name} manages the AI key. Keys are never shown to anyone, including the agency.':
    'Only {name} manages the AI key. Keys are never shown to anyone, including the agency.',
  'Open Materials': 'Open Materials',
  'Open the AI step for {ws} and connect a key. Nothing else: no posts, people or other settings.':
    'Open the AI step for {ws} and connect a key. Nothing else: no posts, people or other settings.',
  'Open the brand kit': 'Open the brand kit',
  'Open their link (demo)': 'Open their link (demo)',
  'Opening hours': 'Opening hours',
  'Past days not used': 'Past days not used',
  'Paste a key first': 'Paste a key first',
  'Paste the key here': 'Paste the key here',
  Period: 'Period',
  'Personal LinkedIn profiles are optional and connected by their owner; they do not block setup.':
    'Personal LinkedIn profiles are optional and connected by their owner; they do not block setup.',
  'Personal profile · connected by its owner': 'Personal profile · connected by its owner',
  'Plan activated. AMY drafts the first batch for your review.':
    'Plan activated. AMY drafts the first batch for your review.',
  'Posting time zone for {ws}': 'Posting time zone for {ws}',
  'Posts go out at this local time. It does not change when someone views the calendar from another time zone.':
    'Posts go out at this local time. It does not change when someone views the calendar from another time zone.',
  'Posts keep their own content language.': 'Posts keep their own content language.',
  'Posts still go out at the workspace time: {zone}.':
    'Posts still go out at the workspace time: {zone}.',
  'Products and offers': 'Products and offers',
  'Publish posts you approve in AMY': 'Publish posts you approve in AMY',
  'Published days': 'Published days',
  'Read basic results such as reach and likes': 'Read basic results such as reach and likes',
  'Reconnect {account}': 'Reconnect {account}',
  'Remove key': 'Remove key',
  'Remove the AI key?': 'Remove the AI key?',
  'Replace with another account': 'Replace with another account',
  'Review the sample posts first.': 'Review the sample posts first.',
  'Review the samples': 'Review the samples',
  'Save business details': 'Save business details',
  Sections: 'Sections',
  'Send connect invitation': 'Send connect invitation',
  'Setup progress': 'Setup progress',
  'Show times in': 'Show times in',
  'Shown the same way in the sidebar, Settings, setup and the calendar.':
    'Shown the same way in the sidebar, Settings, setup and the calendar.',
  'Simulated {network} screen': 'Simulated {network} screen',
  'Skipped for now': 'Skipped for now',
  'Skipped steps stay on the list and are not marked done.':
    'Skipped steps stay on the list and are not marked done.',
  Steps: 'Steps',
  Task: 'Task',
  'Test again': 'Test again',
  'Test passed. AI is working.': 'Test passed. AI is working.',
  'Thank you, {name}': 'Thank you, {name}',
  'The account connected before': 'The account connected before',
  'The key field is empty. Use the demo key, or paste the key you created.':
    'The key field is empty. Use the demo key, or paste the key you created.',
  'The key works, but billing is not set up': 'The key works, but billing is not set up',
  'The last test did not pass. Replace the key or test again.':
    'The last test did not pass. Replace the key or test again.',
  'These apply to you only, not to the workspace.':
    'These apply to you only, not to the workspace.',
  'This is a different account from {old}. {n} upcoming {network} posts would publish to {new} instead.':
    'This is a different account from {old}. {n} upcoming {network} posts would publish to {new} instead.',
  'This is usually temporary. Your key is fine; try again in a minute.':
    'This is usually temporary. Your key is fine; try again in a minute.',
  'This model is not available on your account': 'This model is not available on your account',
  'To do · {time}': 'To do · {time}',
  'Toggle brand drafts for {name}': 'Toggle brand drafts for {name}',
  'Tokens in / out': 'Tokens in / out',
  'Try again': 'Try again',
  'Up to one post per channel per day; about {n} a week from the always-on plan':
    'Up to one post per channel per day; about {n} a week from the always-on plan',
  'Use a demo key': 'Use a demo key',
  'Version {v}': 'Version {v}',
  'Waiting for someone else': 'Waiting for someone else',
  'Waiting for {name} to connect AI': 'Waiting for {name} to connect AI',
  'What changes, e.g. open 10–14': 'What changes, e.g. open 10–14',
  'What it might cost': 'What it might cost',
  'What they can do': 'What they can do',
  'Who you want to reach': 'Who you want to reach',
  'Workspace time ({zone})': 'Workspace time ({zone})',
  'Your brand kit is version {v}, approved by {name}. AMY writes and designs with it.':
    'Your brand kit is version {v}, approved by {name}. AMY writes and designs with it.',
  'Your preferences': 'Your preferences',
  'expired {date}': 'expired {date}',
  'from Business details': 'from Business details',
  'key ending {k}': 'key ending {k}',
  'not every account published; still reserved until retried or cancelled':
    'not every account published; still reserved until retried or cancelled',
  optional: 'optional',
  tokens: 'tokens',
  '{account} is connected': '{account} is connected',
  '{account} is connected to {ws}.': '{account} is connected to {ws}.',
  '{day} closes': '{day} closes',
  '{day} opens': '{day} opens',
  '{list} not connected yet, left out until connected':
    '{list} not connected yet, left out until connected',
  '{name} can change the brand kit draft and business details. Publishing a new brand version stays with the owner.':
    '{name} can change the brand kit draft and business details. Publishing a new brand version stays with the owner.',
  '{name} can view the brand kit but not change it.':
    '{name} can view the brand kit but not change it.',
  '{name} completed the AI connection at {when}.': '{name} completed the AI connection at {when}.',
  '{n} days with a free slot in the next two weeks':
    '{n} days with a free slot in the next two weeks',
  '{n} of {cap} slots available on this day': '{n} of {cap} slots available on this day',
  '{n} photos and videos are in Materials. AMY picks from them; add more any time.':
    '{n} photos and videos are in Materials. AMY picks from them; add more any time.',
  '{n} upcoming {network} posts use this channel, the next on {date}.':
    '{n} upcoming {network} posts use this channel, the next on {date}.',
  '{owner} asked you to connect AI for {ws}': '{owner} asked you to connect AI for {ws}',
  '{owner} asked you to do this one step. You will not see their posts, people or settings.':
    '{owner} asked you to do this one step. You will not see their posts, people or settings.',
  '{provider} did not accept this key': '{provider} did not accept this key',
  '{provider} did not answer': '{provider} did not answer',
  '{provider} · {model}. AMY drafts with this account from now on.':
    '{provider} · {model}. AMY drafts with this account from now on.',
  '{ws} · {n} of {total} done. Do the steps in any order.':
    '{ws} · {n} of {total} done. Do the steps in any order.',
  '{x}: skipped for now. It stays on this list.': '{x}: skipped for now. It stays on this list.',
  Network: 'Network',
  'Allow access': 'Allow access',
  Confirm: 'Confirm',
  'Instagram business or creator account': 'Instagram business or creator account',
  'Personal Instagram accounts cannot publish through AMY.':
    'Personal Instagram accounts cannot publish through AMY.',
  'A Page you manage. Personal Facebook profiles are not supported.':
    'A Page you manage. Personal Facebook profiles are not supported.',
  'TikTok account': 'TikTok account',
  'Video only.': 'Video only.',
  'A page where you are an admin.': 'A page where you are an admin.',
  'Someone’s personal LinkedIn profile': 'Someone’s personal LinkedIn profile',
  'Only that person can connect it. AMY sends them a connect-only invitation.':
    'Only that person can connect it. AMY sends them a connect-only invitation.',
  'Personal account. Switch it to a business or creator account in Instagram first.':
    'Personal account. Switch it to a business or creator account in Instagram first.',
  'Mid-size model (example)': 'Mid-size model (example)',
  'Small model (example)': 'Small model (example)',
  'Large model (example)': 'Large model (example)',
  Works: 'Works',
  'Invalid key': 'Invalid key',
  'Billing needed': 'Billing needed',
  'Model unavailable': 'Model unavailable',
  'Temporary failure': 'Temporary failure',
  'Testing…': 'Testing…',
  'Test failed': 'Test failed',
  Revision: 'Revision',
  'Updated by {name} on {date}': 'Updated by {name} on {date}',
  'Brand kit version {v}': 'Brand kit version {v}',
  '{n} items in Materials': '{n} items in Materials',
  'Waiting for {name}': 'Waiting for {name}',
  '{n} of {total} need attention': '{n} of {total} need attention',
  '{total} accounts connected': '{total} accounts connected',
  '{n} of {total} reviewed': '{n} of {total} reviewed',
  '5–10 min': '5–10 min',
  '5 min': '5 min',
  'Business name': 'Business name',
  Address: 'Address',
  'Shown in posts that mention where to find you.':
    'Shown in posts that mention where to find you.',
  'Public phone': 'Public phone',
  'Public email': 'Public email',
  Website: 'Website',
  'Menu or price list link': 'Menu or price list link',
  'Optional. AMY links to it instead of copying prices.':
    'Optional. AMY links to it instead of copying prices.',
  'Add the address guests should use.': 'Add the address guests should use.',
  'Check the email address.': 'Check the email address.',
  'Check the phone number.': 'Check the phone number.',
  'Use a full link starting with https://': 'Use a full link starting with https://',
  'Replace key': 'Replace key',
  'Replace account': 'Replace account',
  'They keep their approval and publish on time.': 'They keep their approval and publish on time.',
  'They publish to this account once approved.': 'They publish to this account once approved.',
  People: 'People',
  '{network} is not connected': '{network} is not connected',
  'Connect {network}': 'Connect {network}',
  'Enter a full email address, like name@example.com.':
    'Enter a full email address, like name@example.com.',
  '{ws} has no main contact now. Choose one below; until then the client sees “No main contact”.':
    '{ws} has no main contact now. Choose one below; until then the client sees “No main contact”.',
  '{name}’s own choices for {ws}. Others in the workspace choose theirs.':
    '{name}’s own choices for {ws}. Others in the workspace choose theirs.',
  'Show fewer': 'Show fewer',
  'Show all {n} tasks': 'Show all {n} tasks',
  'How this is estimated: each task’s tokens times the example list price of the model it used, per million tokens in / out: small US$ 0.10 / 0.40, mid-size US$ 0.40 / 1.60, large US$ 2 / 8 (checked 3 Nov 2026). Providers bill in US dollars; your provider’s invoice is the real amount.':
    'How this is estimated: each task’s tokens times the example list price of the model it used, per million tokens in / out: small US$ 0.10 / 0.40, mid-size US$ 0.40 / 1.60, large US$ 2 / 8 (checked 3 Nov 2026). Providers bill in US dollars; your provider’s invoice is the real amount.',
  'Saved automatically. {name} reviews and applies it.':
    'Saved automatically. {name} reviews and applies it.',
  'Times in {tz}; posts go out at {posting} time': 'Times in {tz}; posts go out at {posting} time',
  '{account} is connected. {n} posts moved to it and need approval again.':
    '{account} is connected. {n} posts moved to it and need approval again.',
  'This is you, so you can connect your own profile now.':
    'This is you, so you can connect your own profile now.',
  'Connect my own profile': 'Connect my own profile',
  'Connect my profile': 'Connect my profile',
  'Replace {old} with {new}': 'Replace {old} with {new}',
  '{n} upcoming posts move to {new}.': '{n} upcoming posts move to {new}.',
  '{n} of them were approved for {old}; they go back to review, so nothing is published to the new account without approval.':
    '{n} of them were approved for {old}; they go back to review, so nothing is published to the new account without approval.',
  'Until then AMY drafts on Hakusana’s trial allowance, which is not billed to you.':
    'Until then AMY drafts on Hakusana’s trial allowance, which is not billed to you.',
  'goes out at {time} {zone}': 'goes out at {time} {zone}',
  'Waiting for AI': 'Waiting for AI',
  'The AI key was removed, so AMY cannot make version {n} yet. Your request is saved and continues as soon as AI is connected again.':
    'The AI key was removed, so AMY cannot make version {n} yet. Your request is saved and continues as soon as AI is connected again.',
  'Invitation sent {when}': 'Invitation sent {when}',
  'No AI account of yours is connected yet. AMY drafts on Hakusana’s trial allowance, which is not billed to you and not listed here. Your usage appears after you connect AI.':
    'No AI account of yours is connected yet. AMY drafts on Hakusana’s trial allowance, which is not billed to you and not listed here. Your usage appears after you connect AI.',
  'No AI account is connected, so AMY is not drafting and there is no usage to show.':
    'No AI account is connected, so AMY is not drafting and there is no usage to show.',
  'AMY drafts on Hakusana’s trial allowance until you connect your own AI key. Your provider then bills you separately from AMY.':
    'AMY drafts on Hakusana’s trial allowance until you connect your own AI key. Your provider then bills you separately from AMY.',
  'AMY is not drafting: connect an AI key to continue. Requested changes wait until then.':
    'AMY is not drafting: connect an AI key to continue. Requested changes wait until then.',
  'Waiting for an AI connection before making the new version':
    'Waiting for an AI connection before making the new version',
  'Account changed from {from} to {to}; needs approval again':
    'Account changed from {from} to {to}; needs approval again',
  'Connect {account}': 'Connect {account}',
  'Got it. I have saved this as a task. AI is not connected right now, so I will start as soon as it is.':
    'Got it. I have saved this as a task. AI is not connected right now, so I will start as soon as it is.',
  'Thanks for the idea! It is saved. AI is not connected right now, so I will draft it as soon as it is.':
    'Thanks for the idea! It is saved. AI is not connected right now, so I will draft it as soon as it is.',
  'goes out {when} at {time} {zone}': 'goes out {when} at {time} {zone}',
  'Past days awaiting a result': 'Past days awaiting a result',
  'Reserved from today': 'Reserved from today',
  'Free from today': 'Free from today',
  'Only {name} can reconnect this account': 'Only {name} can reconnect this account',
  'Only {name} can connect accounts': 'Only {name} can connect accounts',
  'Invitation sent again to {name} (simulated)': 'Invitation sent again to {name} (simulated)',
  'Current model: {model}': 'Current model: {model}',
  'AI tasks in this period (drafts and revisions)':
    'AI tasks in this period (drafts and revisions)',
  'Tokens in this period': 'Tokens in this period',
  'Estimated cost in this period (US$)': 'Estimated cost in this period (US$)',
  'Daily publishing limits': 'Daily publishing limits',
  'Effective value = the workspace override if one is set, otherwise the agency default, never more than the platform maximum. It is what {ws} sees in its calendar and Plan allowance.':
    'Effective value = the workspace override if one is set, otherwise the agency default, never more than the platform maximum. It is what {ws} sees in its calendar and Plan allowance.',
  'Platform maximum': 'Platform maximum',
  'Agency default (Hakusana)': 'Agency default (Hakusana)',
  'Not connected: nothing can be published until it is':
    'Not connected: nothing can be published until it is',
  'Set an override': 'Set an override',
  'Unused days never carry over. Changes would apply to new bookings; scheduled posts are kept.':
    'Unused days never carry over. Changes would apply to new bookings; scheduled posts are kept.',
  'Set a workspace override': 'Set a workspace override',
  'Hakusana workspaces': 'Hakusana workspaces',
  'View limits': 'View limits',
  '…and {n} more workspaces that are not part of this demo.':
    '…and {n} more workspaces that are not part of this demo.',
  'Message from the client': 'Message from the client',
  Reply: 'Reply',
  'Reply to {name}': 'Reply to {name}',
  'Your reply': 'Your reply',
  'For example: Yes, I have added three posts for your Christmas hours. Please review them.':
    'For example: Yes, I have added three posts for your Christmas hours. Please review them.',
  '{name} sees your reply in AMY and gets a notification.':
    '{name} sees your reply in AMY and gets a notification.',
  'Reply sent to {name}.': 'Reply sent to {name}.',
  'Send reply': 'Send reply',
  'Your messages': 'Your messages',
  'You wrote at {time}': 'You wrote at {time}',
  '{name} from Hakusana replied at {time}': '{name} from Hakusana replied at {time}',
  'Waiting for a reply': 'Waiting for a reply',
  '{name} wrote to Hakusana: {text}': '{name} wrote to Hakusana: {text}',
  '{name} (Hakusana) replied: {text}': '{name} (Hakusana) replied: {text}',
  '{name} from Hakusana replied to your message': '{name} from Hakusana replied to your message',
  'Answer for the client': 'Answer for the client',
  'Or finish it yourself': 'Or finish it yourself',
  'What you did': 'What you did',
  'For example: I called Anna and added the posts to the calendar.':
    'For example: I called Anna and added the posts to the calendar.',
  'Mark as done': 'Mark as done',
  'Task done. The client sees your note.': 'Task done. The client sees your note.',
  '{name} (Hakusana) finished this: {note}': '{name} (Hakusana) finished this: {note}',
  '{name} (Hakusana) finished “{title}”: {note}': '{name} (Hakusana) finished “{title}”: {note}',
  'set by the platform': 'set by the platform',
  '{ws}: {channel} is now {value}. The client sees it in Plan allowance.':
    '{ws}: {channel} is now {value}. The client sees it in Plan allowance.',
  'from the override': 'from the override',
  '{channel} is back to the agency default.': '{channel} is back to the agency default.',
  'Remove override': 'Remove override',
  'Override the limit for {ws}': 'Override the limit for {ws}',
  'Posts per day': 'Posts per day',
  '0 (channel paused)': '0 (channel paused)',
  'Up to the platform maximum of {n}.': 'Up to the platform maximum of {n}.',
  'Result: {channel} goes from {from} to {to} for {ws}. Changes apply to new bookings; scheduled posts are kept.':
    'Result: {channel} goes from {from} to {to} for {ws}. Changes apply to new bookings; scheduled posts are kept.',
  'Prototype note: the new limit shows in the workspace’s Plan allowance and daily allowance. The calendar’s booking rules stay one post per channel per day until the backend applies limits.':
    'Prototype note: the new limit shows in the workspace’s Plan allowance and daily allowance. The calendar’s booking rules stay one post per channel per day until the backend applies limits.',
  'Save override': 'Save override',
  'A caption you like': 'A caption you like',
  'AMY made a new set with your feedback.': 'AMY made a new set with your feedback.',
  'AMY read {url} (simulated in this demo). It found: {found}. You can check everything on the next cards.':
    'AMY read {url} (simulated in this demo). It found: {found}. You can check everything on the next cards.',
  'AMY will use it for every new post. Your first post is waiting for your review; nothing is scheduled until you approve it.':
    'AMY will use it for every new post. Your first post is waiting for your review; nothing is scheduled until you approve it.',
  'Add another profile': 'Add another profile',
  'Add more photos to Materials.': 'Add more photos to Materials.',
  'Add opening hours and contact details.': 'Add opening hours and contact details.',
  'Back to the samples': 'Back to the samples',
  Business: 'Business',
  Captions: 'Captions',
  'Change colour {n}': 'Change colour {n}',
  'Closest to your tone': 'Closest to your tone',
  'Connect a social profile before anything can be scheduled.':
    'Connect a social profile before anything can be scheduled.',
  'Connect a {channel} profile first. Then you can approve and schedule this post.':
    'Connect a {channel} profile first. Then you can approve and schedule this post.',
  'Connect your own AI account. Until then AMY drafts on Hakusana’s trial allowance.':
    'Connect your own AI account. Until then AMY drafts on Hakusana’s trial allowance.',
  'Continue getting started': 'Continue getting started',
  'Demo: use a sample logo': 'Demo: use a sample logo',
  'Demo: use {url}': 'Demo: use {url}',
  'First post': 'First post',
  'From Google Drive or a shared folder': 'From Google Drive or a shared folder',
  'From my phone or computer': 'From my phone or computer',
  'From your website': 'From your website',
  'Getting started: a few questions, then three sample posts in your style':
    'Getting started: a few questions, then three sample posts in your style',
  'Google Drive (simulated): choose a photo': 'Google Drive (simulated): choose a photo',
  'In your own words': 'In your own words',
  'In your own words, e.g. “It looks warm and shows our real shop”':
    'In your own words, e.g. “It looks warm and shows our real shop”',
  'Is there anything I should avoid saying? (optional)':
    'Is there anything I should avoid saying? (optional)',
  'Let AMY choose': 'Let AMY choose',
  'Let me decide after seeing the samples': 'Let me decide after seeing the samples',
  'Link to a post you like': 'Link to a post you like',
  Logo: 'Logo',
  Look: 'Look',
  'Make a new set': 'Make a new set',
  'Never say': 'Never say',
  'New set with your feedback: “{text}”': 'New set with your feedback: “{text}”',
  'No logo or website colours yet. Pick a colour you always use, or let AMY choose.':
    'No logo or website colours yet. Pick a colour you always use, or let AMY choose.',
  'No {channel} profile connected yet': 'No {channel} profile connected yet',
  'None of these': 'None of these',
  'Not set yet': 'Not set yet',
  'Open the setup checklist': 'Open the setup checklist',
  'Or mix and match': 'Or mix and match',
  'Paste a caption you like instead': 'Paste a caption you like instead',
  'Plan my first month': 'Plan my first month',
  'Preview only: no profile connected yet.': 'Preview only: no profile connected yet.',
  'Preview samples without connecting': 'Preview samples without connecting',
  Progress: 'Progress',
  'Question {n} of {total}': 'Question {n} of {total}',
  'Read my website': 'Read my website',
  'Review my first post': 'Review my first post',
  'Same story three ways, in {lang} for {channel}.':
    'Same story three ways, in {lang} for {channel}.',
  'Sample {look} look with sample {cap} captions, for {channel}':
    'Sample {look} look with sample {cap} captions, for {channel}',
  'Sample {n}': 'Sample {n}',
  'Save and exit': 'Save and exit',
  'Save my style': 'Save my style',
  'Saved. Continue any time from the calendar.': 'Saved. Continue any time from the calendar.',
  'Saving puts your first post in Needs your review. Nothing is scheduled until you approve it.':
    'Saving puts your first post in Needs your review. Nothing is scheduled until you approve it.',
  'Still to do, whenever you are ready': 'Still to do, whenever you are ready',
  'Style saved. Your first post is waiting for your review.':
    'Style saved. Your first post is waiting for your review.',
  'Taken from your website. Edit anything that is not right.':
    'Taken from your website. Edit anything that is not right.',
  'That’s it for now': 'That’s it for now',
  Use: 'Use',
  'Use these': 'Use these',
  'Use this caption style': 'Use this caption style',
  'Use this look': 'Use this look',
  'Use this sample': 'Use this sample',
  'Website address': 'Website address',
  'What it is about': 'What it is about',
  'What would you like me to change?': 'What would you like me to change?',
  'What your business does': 'What your business does',
  'When is it?': 'When is it?',
  'When is it? e.g. Friday 27 Nov, 19:00': 'When is it? e.g. Friday 27 Nov, 19:00',
  'Which one for the first sample posts?': 'Which one for the first sample posts?',
  'You can preview and save your style first. A profile is needed before anything is scheduled.':
    'You can preview and save your style first. A profile is needed before anything is scheduled.',
  'You can review and change this post now. To approve and schedule it, connect a profile first.':
    'You can review and change this post now. To approve and schedule it, connect a profile first.',
  'Your logo': 'Your logo',
  'Your style is saved': 'Your style is saved',
  'a logo': 'a logo',
  'a short description': 'a short description',
  'connect {channel} before it can be scheduled': 'connect {channel} before it can be scheduled',
  'e.g. Kawiarnia Zielna': 'e.g. Kawiarnia Zielna',
  'e.g. We’re a café in Warsaw that roasts its own coffee.':
    'e.g. We’re a café in Warsaw that roasts its own coffee.',
  'e.g. less formal, no emoji, show the coffee closer':
    'e.g. less formal, no emoji, show the coffee closer',
  'e.g. no prices, never “cheap”': 'e.g. no prices, never “cheap”',
  'e.g. www.yourbusiness.pl': 'e.g. www.yourbusiness.pl',
  needed: 'needed',
  'only a name': 'only a name',
  'your name': 'your name',
  '{n} colours': '{n} colours',
  'Start as a new client': 'Start as a new client',
  'Your business': 'Your business',
  'Your style': 'Your style',
  'Your channels': 'Your channels',
  'Sample posts': 'Sample posts',
  'Does your business have a website?': 'Does your business have a website?',
  'I can read it and fill in what I find, so you only check it.':
    'I can read it and fill in what I find, so you only check it.',
  'What should I call your business?': 'What should I call your business?',
  'What does your business do?': 'What does your business do?',
  'One or two sentences, as you would tell a new customer.':
    'One or two sentences, as you would tell a new customer.',
  'What language should I write your posts in?': 'What language should I write your posts in?',
  'Do you have a logo you’d like me to use?': 'Do you have a logo you’d like me to use?',
  'Which colours should I keep?': 'Which colours should I keep?',
  'Suggested from your logo or website. Tap a colour to change it.':
    'Suggested from your logo or website. Tap a colour to change it.',
  'Can you show me a photo or post with a look you like?':
    'Can you show me a photo or post with a look you like?',
  'A phone photo of your place is perfect.': 'A phone photo of your place is perfect.',
  'What do you like about this look?': 'What do you like about this look?',
  'Pick any that fit, or say it in your own words.':
    'Pick any that fit, or say it in your own words.',
  'Which of these sounds most like your business?':
    'Which of these sounds most like your business?',
  'Want to add another profile?': 'Want to add another profile?',
  'You can add more later in Settings.': 'You can add more later in Settings.',
  'Where would you like your first post to go?': 'Where would you like your first post to go?',
  'Connect one profile now. You can add more later.':
    'Connect one profile now. You can add more later.',
  'What should your first post be about?': 'What should your first post be about?',
  'Which sample feels most like your business?': 'Which sample feels most like your business?',
  'Here’s what AMY will remember': 'Here’s what AMY will remember',
  'Edit anything before saving. You can change it later on the Brand page.':
    'Edit anything before saving. You can change it later on the Brand page.',
  'Warm light': 'Warm light',
  'Real people': 'Real people',
  'Close-ups': 'Close-ups',
  'Bright colours': 'Bright colours',
  'Calm and minimal': 'Calm and minimal',
  'Natural, not posed': 'Natural, not posed',
  'Warm and personal': 'Warm and personal',
  'Clean and simple': 'Clean and simple',
  'Bright and playful': 'Bright and playful',
  'Short and clear': 'Short and clear',
  'Lively and playful': 'Lively and playful',
  'A new product': 'A new product',
  'An event': 'An event',
  'Introduce my business': 'Introduce my business',
  Both: 'Both',
  Keep: 'Keep',
  'Choose a different file': 'Choose a different file',
  'Choose a file': 'Choose a file',
  'No website': 'No website',
  'e.g. Live music on Friday evening': 'e.g. Live music on Friday evening',
  'e.g. Our new apple cake': 'e.g. Our new apple cake',
  'AMY chooses': 'AMY chooses',
  '{name} finished getting started. AMY saved the style and made the first post for review.':
    '{name} finished getting started. AMY saved the style and made the first post for review.',
  'Made from your setup choices': 'Made from your setup choices',
  'Created during setup': 'Created during setup',
  'Chosen during setup': 'Chosen during setup',
  'Welcome to AMY! A few short questions and I will show you three sample posts in your style.':
    'Welcome to AMY! A few short questions and I will show you three sample posts in your style.',
  'New client (demo)': 'New client (demo)',
  'No brand kit yet': 'No brand kit yet',
  'Answer a few questions in Getting started and AMY creates your brand kit from your logo, colours, a photo you like and your tone.':
    'Answer a few questions in Getting started and AMY creates your brand kit from your logo, colours, a photo you like and your tone.',
  'no profile yet': 'no profile yet',
};
